'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _countryCode, _imageRacingMap;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var configJson = {
  urlToUse: 'local',
  language: 'it',
  endpoints: {
    local: 'http://localhost:9001/',
    development: 'https://dev-api-mtc.gazzetta.it/',
    stag: 'https://dev-api-mtc.gazzetta.it/',
    production: 'https://api2-mtc.gazzetta.it/',
    articles: 'https://smart.gazzetta.it/',
    articlesV2: 'https://searchapiservice.gazzetta.it/api/',
    bet: 'https://json2.gazzettaobjects.it/quote-mc/',
    //probabiliMethode: 'https://json.gazzettaobjects.it/',
    probabiliMethode: 'https://api-matches-lineups.gazzetta.it/api/lineups/team/', //NON PIU' GESTITE DA METHODE MA DA XALOK
    nextApi: 'https://next-api-mtc2.gazzetta.it/',
    'dev-nextApi': 'https://dev-next-api-mtc.gazzetta.it/',
    staticApi: 'https://json2.gazzettaobjects.it/'
  },
  apiVersion: 'v1',
  serviceCollection: {
    hublive: {
      getSportsList: {
        name: function name(paramsObject) {
          if (paramsObject.pref) {
            return 'api/' + paramsObject.version + '/sports/' + paramsObject.date + '?pref=' + paramsObject.pref;
          } else {
            return 'api/' + paramsObject.version + '/sports/' + paramsObject.date;
          }
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getCompetitionsList: {
        name: function name(paramsObject) {
          if (paramsObject.pref) {
            return 'api/' + paramsObject.version + '/sports/' + paramsObject.date + '?sportId=' + paramsObject.id + '&pref=' + paramsObject.pref;
          } else {
            return 'api/' + paramsObject.version + '/sports/' + paramsObject.date + '?sportId=' + paramsObject.id;
          }
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    },
    hubliveFavourites: {
      getYesterdayTomorrow: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/sports/favourites?yesterday=' + paramsObject.yesterdaySportIds + '&tomorrow=' + paramsObject.tomorrowSportIds;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    },
    calendar: {
      getCalendar: {
        name: function name(paramsObject) {
          if (paramsObject.seasonId) {
            return 'api/' + paramsObject.version + '/sports/calendar?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&seasonId=' + paramsObject.seasonId;
          } else {
            return 'api/' + paramsObject.version + '/sports/calendar?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId;
          }
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getCalendarWidgetCorriere: {
        name: function name(paramsObject) {
          if (paramsObject.seasonId) {
            return 'api/' + paramsObject.version + '/sports/calendar?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&isWidget=' + paramsObject.isWidget + '&seasonId=' + paramsObject.seasonId;
          } else {
            return 'api/' + paramsObject.version + '/sports/calendar?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&isWidget=' + paramsObject.isWidget;
          }
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getCalendarTennis: {
        name: function name(paramsObject) {
          if (paramsObject.seasonId) {
            return 'api/' + paramsObject.version + '/sports/calendar?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&order=' + paramsObject.order + '&seasonId=' + paramsObject.seasonId;
          } else {
            return 'api/' + paramsObject.version + '/sports/calendar?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&order=' + paramsObject.order;
          }
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getDayCalendar: {
        name: function name(paramsObject) {
          if (paramsObject.seasonId) {
            return 'api/' + paramsObject.version + '/sports/calendar?day=' + paramsObject.day + '&sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&seasonId=' + paramsObject.seasonId;
          } else {
            return 'api/' + paramsObject.version + '/sports/calendar?day=' + paramsObject.day + '&sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId;
          }
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getCupTabbar: {
        name: function name(paramsObject) {
          if (paramsObject.seasonId) {
            return 'api/' + paramsObject.version + '/info/competition?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&seasonId=' + paramsObject.seasonId;
          } else {
            return 'api/' + paramsObject.version + '/info/competition?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId;
          }
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getDayCupCalendar: {
        name: function name(paramsObject) {
          var urlToCall = 'api/' + paramsObject.version + '/sports/calendar?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId;

          if (paramsObject.phase) {
            urlToCall += '&phase=' + paramsObject.phase;
          }
          if (paramsObject.subPhase) {
            urlToCall += '&subphase=' + paramsObject.subPhase;
          }
          if (paramsObject.isWidget && paramsObject.isWidget === true) {
            urlToCall += '&isWidget=' + paramsObject.isWidget;
          }
          if (paramsObject.seasonId) {
            urlToCall += '&seasonId=' + paramsObject.seasonId;
          }
          return urlToCall;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getSeasonCalendarTennis: {
        name: function name(paramsObject) {
          if (paramsObject.seasonId) {
            return 'api/' + paramsObject.version + '/sports/seasonCalendar?sportId=' + paramsObject.sportId + '&seasonId=' + paramsObject.seasonId;
          } else {
            return 'api/' + paramsObject.version + '/sports/seasonCalendar?sportId=' + paramsObject.sportId;
          }
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getBasketCalendar: {
        name: function name(paramsObject) {
          var urlToCall = 'api/' + paramsObject.version + '/sports/calendar?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId;

          if (paramsObject.day) {
            urlToCall += '&day=' + paramsObject.day;
          }
          if (paramsObject.phase) {
            urlToCall += '&phase=' + paramsObject.phase;
          }
          if (paramsObject.subPhase) {
            urlToCall += '&subphase=' + paramsObject.subPhase;
          }

          if (paramsObject.seasonId) {
            urlToCall += '&seasonId=' + paramsObject.seasonId;
          }
          return urlToCall;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    },
    competitionData: {
      getStandings: {
        name: function name(paramsObject) {
          if (paramsObject.seasonId) {
            return 'api/' + paramsObject.version + '/standings/teams?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&seasonId=' + paramsObject.seasonId;
          } else {
            return 'api/' + paramsObject.version + '/standings/teams?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId;
          }
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getStandingsWithPhase: {
        name: function name(paramsObject) {
          var urlToCall = 'api/' + paramsObject.version + '/standings/teams?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&phase=' + paramsObject.phase;
          if (paramsObject.subPhase) {
            urlToCall += '&subphase=' + paramsObject.subPhase;
          }

          if (paramsObject.seasonId) {
            urlToCall += '&seasonId=' + paramsObject.seasonId;
          }
          return urlToCall;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getTopScorers: {
        name: function name(paramsObject) {
          if (paramsObject.seasonId) {
            return 'api/' + paramsObject.version + '/standings/markers?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&seasonId=' + paramsObject.seasonId;
          } else {
            return 'api/' + paramsObject.version + '/standings/markers?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId;
          }
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getPlayoffPhase: {
        name: function name(paramsObject) {
          if (paramsObject.seasonId) {
            return 'api/' + paramsObject.version + '/standings/playoff?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&seasonId=' + paramsObject.seasonId;
          } else {
            return 'api/' + paramsObject.version + '/standings/playoff?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId;
          }
        },


        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getQualification: {
        name: function name(paramsObject) {
          if (paramsObject.seasonId) {
            return 'api/' + paramsObject.version + '/standings/qualification?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&seasonId=' + paramsObject.seasonId;
          } else {
            return 'api/' + paramsObject.version + '/standings/qualification?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId;
          }
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getCompetitionPhase: {
        name: function name(paramsObject) {
          if (paramsObject.seasonId) {
            return 'api/' + paramsObject.version + '/info/competition?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&seasonId=' + paramsObject.seasonId;
          } else {
            return 'api/' + paramsObject.version + '/info/competition?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId;
          }
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getHallOfFame: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/hallOfFame/competition?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getLastMatches: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/teams/lastMatches?sportId=' + paramsObject.sportId + '&teamId=' + paramsObject.teamId;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getSquad: {
        name: function name(paramsObject) {
          var urlToCall = 'api/' + paramsObject.version + '/teams/squad?sportId=' + paramsObject.sportId;

          if (paramsObject.playerId) {
            urlToCall += '&playerId=' + paramsObject.playerId;
          } else if (paramsObject.competitionId && paramsObject.teamId) {
            urlToCall += '&competitionId=' + paramsObject.competitionId + '&teamId=' + paramsObject.teamId;
          }
          if (paramsObject.seasonId) {
            urlToCall += '&seasonId=' + paramsObject.seasonId;
          }
          return urlToCall;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getUefaStandings: {
        name: function name(paramsObject) {
          var url = '';
          var category = paramsObject.category;

          switch (category) {
            case 'club':
              url = 'Calcio/uefa_standings/club.json';
              break;
            case 'international':
              url = 'Calcio/uefa_standings/international.json';
              break;
            case 'dictionary':
              url = 'Calcio/uefa_standings/dictionary.json';
              break;
            default:
              url = 'Calcio/uefa_standings/club.json';
              break;
          }
          return url;
        },
        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getCyclingHallOfFame: {
        name: function name(paramsObject) {
          return 'CyclingHallOfFame/' + paramsObject.competitionId + '/standings.json';
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    },
    teamData: {
      getClubInfo: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/teams/clubInfo?sportId=' + paramsObject.sportId + '&teamId=' + paramsObject.teamId;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getHeaderInfo: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/teams/globalInfo?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&teamId=' + paramsObject.teamId;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getTeamCalendar: {
        name: function name(paramsObject) {
          if (paramsObject.seasonId) {
            return 'api/' + paramsObject.version + '/teams/calendar?sportId=' + paramsObject.sportId + '&teamId=' + paramsObject.teamId + '&seasonId=' + paramsObject.seasonId;
          } else {
            return 'api/' + paramsObject.version + '/teams/calendar?sportId=' + paramsObject.sportId + '&teamId=' + paramsObject.teamId;
          }
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    },
    match: {
      getHeaderInfo: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/events/live?sportId=' + paramsObject.sportId + '&matchId=' + paramsObject.matchId + '&competitionId=' + paramsObject.competitionId;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getArticles: {
        name: function name(paramsObject) {
          return 'ricerca-calcio/' + paramsObject.homeTeam + '/' + paramsObject.awayTeam + '/' + paramsObject.competitionName;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getArticlesV2: {
        name: function name(paramsObject) {
          return 'search/mtc/?find=headline:' + paramsObject.homeTeam + '|' + paramsObject.awayTeam + '&section=' + paramsObject.competitionName + '&rows=' + paramsObject.maxResults;
        },

        type: 'GET',
        content: 'application/json;charset=UTF-8'
      },
      getArticlesByTeam: {
        name: function name(paramsObject) {
          return 'search/mtc/?section=' + paramsObject.competitionName + '/' + paramsObject.homeTeam + '|' + paramsObject.competitionName + '/' + paramsObject.awayTeam + '&rows=' + paramsObject.maxResults;
        },

        type: 'GET',
        content: 'application/json;charset=UTF-8'
      },
      getReports: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/events/commentary?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&matchId=' + paramsObject.matchId + '&period=' + paramsObject.period + '&lang=it';
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getFacts: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/events/facts?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&matchId=' + paramsObject.matchId;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getSynthesis: {
        name: function name(paramsObject) {
          if (paramsObject.newformat) {
            return 'api/' + paramsObject.version + '/events/synthesis?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&matchId=' + paramsObject.matchId + '&lang=it';
          } else {
            return 'api/' + paramsObject.version + '/events/commentary?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&matchId=' + paramsObject.matchId + '&period=' + paramsObject.period + '&lang=it&synthesis=true';
          }
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getLineups: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/events/lineup?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&matchId=' + paramsObject.matchId;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getStatistics: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/events/stats?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&matchId=' + paramsObject.matchId;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getHeadToHead: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/events/headtohead?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&matchId=' + paramsObject.matchId;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getVotations: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/events/votations?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&matchId=' + paramsObject.matchId;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getArticlesTennis: {
        name: function name(paramsObject) {
          return 'ricerca-tennis/' + paramsObject.firstEntry + '/' + paramsObject.SecondEntry + '/';
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getArticlesTennisV2: {
        name: function name(paramsObject) {
          return 'search/mtc/?find=headline:' + paramsObject.firstEntry + '|' + paramsObject.SecondEntry + '&section=Tennis&rows=' + paramsObject.maxResults;
        },

        type: 'GET',
        content: 'application/json;charset=UTF-8'
      },
      getAllMatches: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/events/allMatches?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&matchId=' + paramsObject.matchId;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    },
    player: {
      getInfo: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/players/info?sportId=' + paramsObject.sportId + '&playerId=' + paramsObject.playerId;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getBio: {
        name: function name(paramsObject) {
          return 'api/info/v1/player/biography?sportId=' + paramsObject.sportId + '&playerId=' + paramsObject.playerId;
        },
        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getStats: {
        name: function name(paramsObject) {
          if (paramsObject.competitionId) {
            return 'api/' + paramsObject.version + '/players/stats?sportId=' + paramsObject.sportId + '&playerId=' + paramsObject.playerId + '&competitionId=' + paramsObject.competitionId;
          } else {
            return 'api/' + paramsObject.version + '/players/stats?sportId=' + paramsObject.sportId + '&playerId=' + paramsObject.playerId;
          }
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getMagicStats: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/players/magicStats?sportId=' + paramsObject.sportId + '&playerId=' + paramsObject.playerId + '&competitionId=' + paramsObject.competitionId;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getMagicDetails: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/players/magicDetails?sportId=' + paramsObject.sportId + '&playerId=' + paramsObject.playerId + '&competitionId=' + paramsObject.competitionId;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    },
    raceData: {
      getDriverStandings: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/standings/drivers?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getConstructorStandings: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/standings/constructors?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getTeamsStandings: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/standings/teams?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getHeaderInfo: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/events/live?sportId=' + paramsObject.sportId + '&matchId=' + paramsObject.matchId + '&competitionId=' + paramsObject.competitionId;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getStatistics: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/events/stats?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&matchId=' + paramsObject.matchId + '&phase=' + paramsObject.phase;
        },


        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getArticles: {
        name: function name(paramsObject) {
          return 'ricerca/' + paramsObject.sportName + '/' + paramsObject.gpName;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getArticlesV2: {
        name: function name(paramsObject) {
          return 'search/mtc/?find=headline:' + paramsObject.gpName + '&section=' + paramsObject.sportName + '&rows=' + paramsObject.maxResults;
        },

        type: 'GET',
        content: 'application/json;charset=UTF-8'
      },
      getSessionsList: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/events/sessions?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&gpId=' + paramsObject.gpId;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getSession: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/events/sessions?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&gpId=' + paramsObject.gpId + '&session=' + paramsObject.session;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    },
    cyclingData: {
      cyclingStageStandings: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/standings/cycling?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&standingType=' + paramsObject.standingType + '&phase=' + paramsObject.phase;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      cyclingStandings: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/standings/cycling?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&standingType=' + paramsObject.standingType;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getSeasonCalendarUci: {
        name: function name(paramsObject) {
          if (paramsObject.seasonId) {
            return 'api/' + paramsObject.version + '/sports/seasonCalendar?sportId=' + paramsObject.sportId + '&seasonId=' + paramsObject.seasonId;
          } else {
            return 'api/' + paramsObject.version + '/sports/seasonCalendar?sportId=' + paramsObject.sportId;
          }
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    },
    skiData: {
      skiStageStandings: {
        name: function name(paramsObject) {
          if (paramsObject.seasonId) {
            return 'api/' + paramsObject.version + '/standings/ski?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&eventId=' + paramsObject.eventId + '&seasonId=' + paramsObject.seasonId;
          } else {
            return 'api/' + paramsObject.version + '/standings/ski?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&eventId=' + paramsObject.eventId;
          }
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      skiStandings: {
        name: function name(paramsObject) {
          if (paramsObject.seasonId) {
            return 'api/' + paramsObject.version + '/standings/ski?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&seasonId=' + paramsObject.seasonId;
          } else {
            return 'api/' + paramsObject.version + '/standings/ski?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId;
          }
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getSeasonCalendarSki: {
        name: function name(paramsObject) {
          if (paramsObject.seasonId) {
            return 'api/' + paramsObject.version + '/sports/calendar?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&seasonId=' + paramsObject.seasonId;
          } else {
            return 'api/' + paramsObject.version + '/sports/calendar?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId;
          }
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    },
    widgets: {
      getLeafEvent: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/widget/leafEvent?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&matchId=' + paramsObject.matchId;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getLeafCompetition: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/widget/leafCompetition?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&oldestFirst=' + paramsObject.oldestFirst;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getNextMatch: {
        name: function name(paramsObject) {
          if (paramsObject.competitionId) {
            return 'api/' + paramsObject.version + '/widget/nextMatch?sportId=' + paramsObject.sportId + '&teamId=' + paramsObject.teamId + '&competitionId=' + paramsObject.competitionId;
          } else {
            return 'api/' + paramsObject.version + '/widget/nextMatch?sportId=' + paramsObject.sportId + '&teamId=' + paramsObject.teamId;
          }
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getHeaderCorriere: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/widget/headerCorriere?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&oldestFirst=' + paramsObject.oldestFirst;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getTeamCalendar: {
        name: function name(paramsObject) {
          if (paramsObject.seasonId) {
            return 'api/' + paramsObject.version + '/teams/calendar?sportId=' + paramsObject.sportId + '&teamId=' + paramsObject.teamId + '&seasonId=' + paramsObject.seasonId + '&isWidget=' + paramsObject.isWidget;
          } else {
            return 'api/' + paramsObject.version + '/teams/calendar?sportId=' + paramsObject.sportId + '&teamId=' + paramsObject.teamId + '&isWidget=' + paramsObject.isWidget;
          }
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    },
    betting: {
      getBetMatch: {
        name: function name(paramsObject) {
          return paramsObject.sportId + '/' + paramsObject.competitionId + '/' + paramsObject.betterName + '/full.json';
        },

        type: 'GET',
        content: 'application/json;charset=UTF-8'
      }
    },
    probabiliMethode: {
      getProbabiliMethode: {
        name: function name(paramsObject) {
          return '?competitionId=' + paramsObject.competitionId + '&teamId=' + paramsObject.squad;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    },
    nextSportsApi: {
      daily: {
        name: function name(paramsObject) {
          return 'api/sports/v1/daily/' + paramsObject.date;
        },
        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    }
  },

  filterBar: {
    sports: [{
      id: '1',
      name: 'calcio',
      label: 'calcio',
      isAvailable: false,
      isSelected: false
    }, {
      id: '8',
      name: 'tennis',
      label: 'tennis',
      isAvailable: false,
      isSelected: false
    }, {
      id: '3',
      name: 'basket',
      label: 'basket',
      isAvailable: false,
      isSelected: false
    }, {
      id: '6C',
      name: 'f1',
      label: 'Automobilismo',
      isAvailable: false,
      isSelected: false
    }, {
      id: '6M',
      name: 'moto',
      label: 'Motociclismo',
      isAvailable: false,
      isSelected: false
    }]
  },
  sportRefreshInterval: {
    1: 5000,
    2: 60000,
    8: 60000,
    3: 20000
  },
  dictionary: {
    it: {
      date: {
        months: ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'],
        days: ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato']
      },
      tooltip: {
        add: 'Aggiunto ai tuoi preferiti'
      },
      calendar: {
        legs: {
          firstLeg: 'Andata',
          secondLeg: 'Ritorno'
        },
        phases: {
          groups: 'Fase a gironi',
          groups_5_34: 'Fase a round',
          groups_5_35: 'Fase a gironi',
          playoffs: 'Fase finale',
          playoffs_1_105: 'Playoff',
          playout: 'Playout',
          playoffs_2: 'Playoff',
          playoffs_3: 'Playoff',
          extraPlayoffs: 'Playoff 5°-8°',
          playoffs_5: 'Playoff',
          playoffs_5_34: 'Fase finale',
          playoffs_5_35: 'Fase finale',
          preliminaries: 'Qualificazioni',
          preSeason_3: 'Pre season',
          regularSeason: 'Stagione regolare',
          'regular-season': 'Stagione regolare',
          'NBACup': 'NBA Cup',
          'championship': 'Girone Unico'
        },
        subPhases: {
          playOffs: 'Spareggi',
          round1: '1° turno',
          round2: '2° turno',
          round3: '3° turno',
          round4: '4° turno',
          'qualifier-round-1': '1° turno',
          'round-1': '1° turno',
          'round-2': '2° turno',
          'round-3': '3° turno',
          'round-4': '4° turno',
          'play-offs': 'Spareggi',
          preliminary: 'Spareggi',
          1: '1',
          2: '2',
          3: '3',
          4: '4',
          5: '5',
          6: '6',
          round: 'Spareggi',
          'round-of-32': 'Sedicesimi',
          'round-of-16': 'Ottavi',
          'quarter-finals': 'Quarti',
          'semi-finals': 'Semifinali',
          finals: 'Finale',
          '3rd-and-4th-place': 'Finale per il 3° posto',
          '3rd-place-final': 'Finale per il 3° posto',
          '5th-place-final': 'Finale per il 5° posto',
          'qualifier-round': '1° turno',
          'qualifier-round-el': 'Preliminari',
          final: 'Finale',
          'conference-round-1': '1° turno',
          'conference-round-2': '2° turno',
          'conference-semifinals': 'Semifinale di Conference',
          'conference-finals': 'Finale di Conference',
          'nba-finals': 'Finals',
          conferences: 'Conference',
          divisions: 'Division',
          sf_2: 'Semifinali',
          final_2: 'Finale',
          'play-off-qualifying': 'Playoff',
          'classification-round_3': 'Girone perdenti',
          '2nd-round_3': '2&deg; girone',
          'group-stage_3': '1&deg; girone',
          '5th-place-play-offs_3': 'Playoff 5&deg; posto',
          'quarter-finals_3': 'Quarti',
          'semi-finals_3': 'Semifinali',
          '7th-place-final_3': 'Finale 7&deg; posto',
          '5th-place-final_3': 'Finale 5&deg; posto',
          '3rd-place-final_3': 'Finale 3&deg; posto',
          '3rd-place-finals_3': 'Finale 3&deg; posto',
          final_3: 'Finale',
          '3rd-place-final_5': 'Finale per il 3&deg; posto',
          'play-offs_1_335': 'Finale per il 5&deg; posto',
          'quarter-finals_1_335': '2&deg; turno'
        },
        exceptionLablesCompetition: {
          259: {
            'qualifier-round': 'Preliminari',
            'Qualifier Round': 'Preliminari'
          },
          5: {
            'qualifier-round': 'Preliminari',
            'Qualifier Round': 'Preliminari'
          }
        },
        special: {
          phases: {
            playout: 'Playout',
            playoffs: 'Playoff'
          },
          subPhases: {
            preliminary: 'Spareggi',
            'semi-finals': 'Semifinali',
            final: 'Finale'
          }
        },
        tennis: {
          phases: {
            '1st Round': '1° Turno',
            '2nd Round': '2° Turno',
            '3rd Round': '3° Turno',
            '4th Round': '4° Turno',
            'Quarter-final': 'Quarti',
            'Quarter-Final': 'Quarti',
            'Semi-final': 'Semifinali',
            Final: 'Finale',
            '1-128-final': 'Sessantaquattresimi',
            '1-64-final': 'Trentaduesimi',
            '1-32-final': 'Sedicesimi',
            '1-16-final': 'Ottavi',
            'quarter-finals': 'Quarti',
            'semi-finals': 'Semifinali',
            '3rd-place': 'Finale terzo posto',
            final: 'Finale',
            'group-stage': 'Fase a gruppi',
            'qualifying-1st-round': 'Qualificazioni 1° Turno',
            'qualifying-2nd-round': 'Qualificazioni 2° Turno',
            'qualifying-3rd-round': 'Qualificazioni 3° Turno',
            'qualifying-final': 'Qualificazioni Finale',
            'world-group-play-offs': 'Spareggi'
          }
        }
      },
      lineups: {
        lineupInfo: 'Formazioni ufficiali',
        previewLineup: 'Probabili formazioni',
        referee: 'Arbitro',
        mainPlayers: 'Titolari',
        benchPlayers: 'Panchina',
        unavailablePlayers: 'Indisponibili',
        warnedPlayers: 'Diffidati',
        otherPlayers: 'Altri',
        suspendedPlayers: 'Squalificati',
        ballotPlayers: 'Ballottaggi',
        coach: 'Allenatore',
        linemans: 'Guardalinee',
        fourthOfficial: 'Quarto uomo',
        varReferee: 'VAR'
      },
      votations: {
        lineupInfo: 'Formazioni ufficiali',
        referee: 'Arbitro',
        mainPlayers: 'In campo',
        benchPlayers: 'A disposizione',
        unavailablePlayers: 'Indisponibili',
        warnedPlayers: 'Diffidati',
        otherPlayers: 'Altri',
        suspendedPlayers: 'Squalificati',
        ballotPlayers: 'Ballottaggi',
        coach: 'Allenatore',
        linemans: 'Guardalinee',
        fourthOfficial: 'Quarto uomo',
        varReferee: 'VAR'
      },
      filterBar: {
        filterTitle: 'Filtra per: ',
        allSport: 'Tutti',
        live: 'live',
        dropdown: [{
          label: 'ieri',
          value: 'yesterday'
        }, {
          label: 'oggi',
          value: 'today'
        }, {
          label: 'domani',
          value: 'tomorrow'
        }]
      },
      competitionTable: {
        allMatches: 'Vedi tutta la giornata',
        calendar: 'Calendario e risultati',
        standings: 'Classifica',
        roundPhase: 'Fase a gironi',
        playoffPhase: 'Playoff',
        qualification: 'Qualificazioni',
        day: 'giornata',
        dayA: 'ª giornata',
        dayAServer: '&ordf; giornata',
        timing: {
          'Full Time': 'Fine',
          FINISHED: 'Fine',
          'First Half': '1°T',
          'Half Time': 'Fine 1°T',
          'Second Half': '2°T',
          'Pre Match': '',
          FullTime: 'Fine',
          FullTime90: 'Fine 2° Tempo',
          FullTimePens: 'Fine 2° TS',
          FirstHalf: '1°T',
          HalfTime: 'Fine 1°T',
          SecondHalf: '2°T',
          PreMatch: '',
          ExtraFirstHalf: '1° TS',
          ExtraHalfTime: 'Fine 1°TS',
          ExtraSecondHalf: '2° TS',
          ShootOut: 'Calci di rigore',
          Abandoned: 'Interrotta',
          Postponed: 'Rinviata',
          Notplayed: 'non disputata',
          Delayed: 'Posticipato',
          Suspended: 'Sospeso',
          Cancelled: 'Cancellato',
          Walkover: 'Tavolino',
          Live: 'Live',
          header: {
            'Full Time': 'Fine',
            'First Half': '1° Tempo',
            'Half Time': 'Fine 1° Tempo',
            'Second Half': '2° Tempo',
            'Pre Match': '',
            ExtraFirstHalf: '1° tempo Suppl.',
            ExtraHalfTime: 'Fine 1° TS',
            ExtraSecondHalf: '2° tempo Suppl.',
            ShootOut: 'Calci di rigore',
            FullTime: 'Fine',
            FullTime90: 'Fine 2° Tempo',
            FullTimePens: 'Fine 2° TS',
            FirstHalf: '1° Tempo',
            HalfTime: 'Fine 1° Tempo',
            SecondHalf: '2° Tempo',
            PreMatch: '',
            Abandoned: 'Interrotta',
            Postponed: 'Rinviata',
            Notplayed: 'non disputata',
            Delayed: 'Posticipato',
            Suspended: 'Sospeso',
            Cancelled: 'Cancellato'
          }
        },
        basketTiming: {
          1: '1°T',
          2: '2°T',
          3: 'Q1',
          4: 'Q2',
          5: 'Q3',
          6: 'Q4',
          7: 'OT',
          11: 'Fine 1°Q',
          12: 'Fine 1°T',
          13: 'Fine 3°Q',
          14: 'Fine 2°T',
          15: 'Fine',
          header: {
            1: '1°T',
            2: '2°T',
            3: 'Q1',
            4: 'Q2',
            5: 'Q3',
            6: 'Q4',
            7: 'OT',
            11: 'Fine 1°Q',
            12: 'Fine 1°T',
            13: 'Fine 3°Q',
            14: 'Fine 2°T',
            15: 'Fine'
          }
        },
        competitionName: {
          3: 'Europei',
          235: 'Qualificazioni Europei',
          352: 'Europei U21',
          383: 'Europei U19',
          4: 'Mondiali',
          408: 'Mondiali Femminili',
          616: 'Europei Femminili',
          21: 'Serie A',
          105: 'Serie B',
          128: 'Copa America',
          1105: 'Serie B',
          259: 'Coppa Italia',
          232: 'Qualificazioni CL',
          5: 'Champions League',
          548: 'Coppa dei Campioni',
          524: 'Qualificazioni EL',
          6: 'Europa League',
          1125: 'Conference League',
          1126: 'Qualificazioni Conference League',
          173: 'Supercoppa Italiana',
          174: 'Supercoppa Europea',
          8: 'Premier League',
          24: 'Ligue 1',
          23: 'Liga',
          22: 'Bundesliga',
          1277: 'Coppa del Mondo per Club',
          335: 'Coppa del Mondo per Club 2023',
          941: 'Nations League',
          34: 'Amichevole',
          88: 'Amichevole',
          35: 'Amichevole U21',
          514: 'Serie D',
          515: 'Serie D',
          516: 'Serie D',
          517: 'Serie D',
          518: 'Serie D',
          520: 'Serie D',
          521: 'Serie D',
          522: 'Serie D',
          167: 'Serie C Girone A',
          357: 'Serie C Girone B',
          728: 'Serie C Girone C',
          345: 'Qualificazioni Mondiali',
          330: 'Confederations Cup',
          129: 'Premier Liga Russia (RUS)',
          9: 'Eredivisie (OLA)',
          99: 'LPFP Portogallo (POR)',
          363: 'Brasileirao (BRA)',
          724: 'Primera Division (ARG)',
          116: 'Prva HNL Croazia (CRO)',
          113: 'Greece Superleague (GRE)',
          115: 'Super Lig Turchia (TUR)',
          112: 'Begisch Pro League (BEL)',
          135: 'Swiss Super League (SUI)',
          370: 'Apertura Cile (CHI)',
          558: 'Clausura Cile (CHI)',
          199: 'Apertura Messico (MES)',
          385: 'Clausura Messico (MES)',
          367: 'Primera Division Uruguay (URU)',
          588: 'Campionato Uruguay (clausura)',
          14: 'Premier League Scozia (SCO)',
          371: 'Apertura Colombia (COL)',
          589: 'Clausura Colombia (COL)',
          1166: 'Finale Conmebol/Uefa',
          0: 'Totale'
        },
        rugbyCompetitionName: {
          209: '6 Nazioni',
          212: 'Top 12'
        },
        raceCompetitionName: {
          1: 'F1',
          2: 'SBK',
          3: 'Moto GP',
          4: 'Moto 2',
          5: 'Moto 3'
        },
        raceCompetitionLongName: {
          1: 'Formula 1',
          2: 'SBK',
          3: 'Moto GP',
          4: 'Moto 2',
          5: 'Moto 3'
        },
        gpName: {
          Australia: 'Australia',
          Austria: 'Austria',
          Azerbaijan: 'Azerbaigian',
          Argentina: 'Argentina',
          Bahrain: 'Bahrain',
          Belgium: 'Belgio',
          Brazil: 'Brasile',
          'Czech Republic': 'Repubblica Ceca',
          Canada: 'Canada',
          China: 'Cina',
          France: 'Francia',
          Germany: 'Germania',
          'Great Britain': 'Gran Bretagna',
          Hungary: 'Ungheria',
          Kazakhstan: 'Kazakistan',
          Italy: 'Italia',
          India: 'India',
          Indonesia: 'Indonesia',
          Japan: 'Giappone',
          Malaysia: 'Malesia',
          Mexico: 'Messico',
          Monaco: 'Monaco',
          Netherlands: 'Olanda',
          Portugal: 'Portogallo',
          Qatar: 'Qatar',
          Russia: 'Russia',
          'San Marino': 'San Marino',
          'Saudi Arabia': 'Arabia Saudita',
          Singapore: 'Singapore',
          Spain: 'Spagna',
          Thailand: 'Thailandia',
          Toscana: 'Toscana Ferrari 1000',
          USA: 'USA',
          'United States of America': 'USA',
          'United Arab Emirates': 'Abu Dhabi',
          'United Kingdom': 'Gran Bretagna',
          Vietnam: 'Vietnam',
          Finland: 'Finlandia',
          Turkey: 'Turchia'
        },
        gpNameWithGrammar: {
          Australia: "D'Australia",
          Austria: "D'Austria",
          Azerbaijan: "D'Azerbaigian",
          Argentina: "D'Argentina",
          Bahrain: 'Del Bahrain',
          Belgium: 'Del Belgio',
          Brazil: 'Del Brasile',
          'Czech Republic': 'Della Repubblica Ceca',
          Canada: 'Del Canada',
          China: 'Di Cina',
          France: 'Di Francia',
          Germany: 'Di Germania',
          'Great Britain': 'Di Gran Bretagna',
          Hungary: 'Di Ungheria',
          Kazakhstan: 'Del Kazakistan',
          Italy: "D'Italia",
          India: "D'India",
          Japan: 'Del Giappone',
          Malaysia: 'Della Malesia',
          Mexico: 'Del Messico',
          Monaco: 'Di Monaco',
          Netherlands: "D'Olanda",
          Portugal: 'Del Portogallo',
          Qatar: 'Del Quatar',
          Russia: 'Di Russia',
          'San Marino': 'Di San Marino',
          Singapore: 'Di Singapore',
          Spain: 'Di Spagna',
          Thailand: 'Della Thailandia',
          USA: 'Degli USA',
          'United Arab Emirates': 'Di Abu Dhabi',
          'United Kingdom': 'Di Gran Bretagna'
        },
        gpStatus: {
          TOAPPROVAL: 'Rinviata',
          TBD: 'Rinviata',
          ABORTED: 'Annullata',
          FINISHED: 'Fine',
          'ON TRACK': 'Live'
        },
        gpPhases: {
          FP: 'Prove libere',
          FP1: 'Prove libere 1',
          FP2: 'Prove libere 2',
          FP3: 'Prove libere 3',
          FP4: 'Prove libere 4',
          QUALI: 'Qualifiche',
          SPRINTQUALI: 'Gara Sprint',
          SUPERPOLE: 'Superpole',
          WARMUP: 'Warmup',
          SPRINTRACE: 'Gara Sprint',
          SPRINTSHOOTOUT: 'Qualifiche Sprint',
          RACE: 'Gara',
          RACE1: 'Gara 1',
          RACE_SUPERPOLE: 'Race Superpole',
          RACE2: 'Gara 2'
        },
        roundName: {
          'Round of 32': 'Sedicesimi di finale',
          'Round of 16': 'Ottavi di finale',
          'round-of-16': 'Ottavi di finale',
          'Quarter-Finals': 'Quarti di finale',
          'quarter-finals': 'Quarti di finale',
          'Semi-Finals': 'Semifinali',
          'semi-finals': 'Semifinali',
          Round: 'Giornata 1',
          'Play-Offs': 'Playoff',
          '3rd and 4th Place': 'Finale per il 3° posto',
          '3rd-and-4th-place': 'Finale per il 3° posto',
          Final: 'Finale',
          final: 'Finale',
          'Play Out': 'Play out',
          'Play-Out': 'Play out',
          Preliminary: 'Playoff Preliminari',
          'Qualifier Round': 'Turno di qualificazioni',
          'conference-round-1': '1&deg; turno',
          'conference-round-2': '2&deg; turno',
          'conference-semifinals': 'Semifinale di Conference',
          'conference-finals': 'Finale di Conference',
          'nba-finals': 'Finals'
        },
        roundNameTennis: {
          '1st Round': '1° Turno',
          '2nd Round': '2° Turno',
          '3rd Round': '3° Turno',
          '4th Round': '4° Turno',
          'Quarter-final': 'Quarti',
          'Quarter-Final': 'Quarti',
          'Semi-final': 'Semifinali',
          Final: 'Finale',
          '1-128-final': 'Sessantaquattresimi',
          '1-64-final': 'Trentaduesimi',
          '1-32-final': 'Sedicesimi',
          '1-16-final': 'Ottavi',
          'quarter-finals': 'Quarti',
          'semi-finals': 'Semifinali',
          '3rd-place': 'Finale terzo posto',
          final: 'Finale',
          'group-stage': 'Fase a gruppi',
          'qualifying-1st-round': 'Qualificazioni 1° Turno',
          'qualifying-2nd-round': 'Qualificazioni 2° Turno',
          'qualifying-3rd-round': 'Qualificazioni 3° Turno',
          'qualifying-final': 'Qualificazioni Finale',
          'world-group-play-offs': 'Spareggi'
        },
        roundNameMobile: {
          'Qualifier Round': '1&deg; turno',
          'Round 1': '1&deg; turno',
          'Round 2': '2&deg; turno',
          'Round 3': '3&deg; turno',
          'Round 4': '4&deg; turno',
          'Play-Offs': 'Spareggi',
          'Round of 32': 'Sedicesimi',
          'Round of 16': 'Ottavi',
          'Quarter-Finals': 'Quarti',
          'Semi-Finals': 'Semifinali',
          Final: 'Finale',
          '3rd and 4th Place': 'Finale per il 3&deg; posto',
          'Play Out': 'Play out',
          'Play-Out': 'Play out',
          Preliminary: 'Playoff Preliminari'
        },
        roundNameMobileCorriere: {
          'Round of 32': 'Sedicesimi',
          'Round of 16': 'Ottavi',
          'Quarter-Finals': 'Quarti',
          'Semi-Finals': 'Semifinali',
          Round: 'Giornata 1',
          'Play-Offs': 'Playoff',
          Final: 'Finale',
          '3rd and 4th Place': 'Finale per il 3° posto',
          'Play Out': 'Play out',
          'Play-Out': 'Play out',
          Preliminary: 'Preliminari'
        },
        matchColor: {
          L: 'P',
          W: 'V',
          D: 'N'
        },
        tennisCompetitionName: {
          'Mens Singles': 'Singolare Maschile',
          'Womens Singles': 'Singolare Femminile',
          'Mens Doubles': 'Doppio Maschile',
          'Womens Doubles': 'Doppio Femminile',
          'Mixed Doubles': 'Doppio Misto',
          'Davis Cup Mens': 'Maschile',
          'Davis Cup Womens': 'Femminile',
          'Czech Republic Vs Usa Singles': 'Czech Republic Vs Usa Singles',
          'Czech Republic Vs Usa Doubles': 'Czech Republic Vs Usa Doubles',
          'Lille Challenger': 'Lille Challenger',
          'Mens National Teams': 'Nazionale Maschile'
        },
        tennisTournamentType: {
          'ATP World Tour 250': 'ATP',
          'Grand Slam': 'Grande Slam',
          'ATP World Tour Masters 1000': 'Masters 1000',
          'ATP Masters 1000': 'Masters 1000',
          'ATP World Tour 500': 'Master 500',
          'ATP World Tour Finals': 'ATP',
          'ATP Challenger': 'Challenger',
          'ATP 250': 'ATP',
          'ATP 500': 'Master 500',
          'ATP Masters 1000 / WTA 1000': 'Masters 1000',
          'ATP Finals': 'Finals',
          'WTA Finals': 'Finals',
          'WTA Premier': 'WTA',
          'WTA International': 'WTA',
          'WTA 500': 'WTA',
          'WTA 250': 'WTA',
          'WTA 1000': 'WTA',
          'WTA 125': 'WTA',
          'WTA 125s': 'WTA',
          'Season-Ending Championships': 'WTA',
          Olympics: 'Olimpiadi',
          'Laver cup': 'Laver Cup',
          'Davis Cup': 'Davis Cup',
          'Fed Cup': 'Fed Cup',
          'ATP Challenger Tour': 'Challenger',
          Masters: 'Masters 1000',
          ATP250: 'ATP',
          ATP500: 'Master 500',
          'World Championship': 'Finals',
          'WTA 125K Series': 'WTA',
          Normal: 'Finals'
        },
        cyclingTableType: {
          Individual: 'Generale',
          Montaña: 'Scalatori',
          Puntos: 'A punti',
          Jóvenes: 'Giovani',
          Jovenes: 'Giovani',
          Equipos: 'Squadre',
          Abandonos: 'Ritirati'
        }
      },
      dynamicTable: {
        cols: {
          competitionTeams: {
            teamName: '',
            teamId: '',
            drawn: 'N',
            englishMean: 'MI',
            form: 'Forma',
            goalsConceded: 'Gs',
            goalsMade: 'Gf',
            lost: 'P',
            played: 'G',
            points: 'Pt.',
            position: '',
            startingPosition: '',
            won: 'V',
            titleLabel: function titleLabel(id) {
              return 'GRUPPO ' + id;
            },
            toolTip: {
              titleLabel: function titleLabel() {
                return '';
              },
              drawn: 'Pareggi',
              englishMean: 'Media Inglese',
              goalsConceded: 'Goal subiti',
              goalsMade: 'Goal fatti',
              lost: 'Perse',
              played: 'Giocate',
              points: 'Punti',
              position: '',
              won: 'Vittorie'
            }
          },
          standingTeams: {
            teamOfficialName: '',
            drawn: 'N',
            setsAgainst: 'Sp',
            setsPro: 'Sv',
            matchesLost: 'P',
            matchesTotal: 'T',
            points: 'Pt.',
            rank: '',
            matchesWon: 'V',
            teamId: '',
            title: '',
            titleLabel: function titleLabel(id) {
              return 'GRUPPO ' + id;
            },
            toolTip: {
              titleLabel: function titleLabel() {
                return '';
              },
              drawn: 'Pareggi',
              englishMean: 'Media Inglese',
              goalsConceded: 'Goal subiti',
              goalsMade: 'Goal fatti',
              lost: 'Perse',
              played: 'Giocate',
              points: 'Punti',
              position: '',
              won: 'Vittorie',
              matchesTotal: 'Totali',
              matchesWon: 'Vinte',
              matchesLost: 'Perse',
              setsPro: 'Set Vinti',
              setsAgainst: 'Set Persi'
            }
          },
          basketStandings: {
            lost: 'P',
            pointsConceded: 'PS',
            pointsScored: 'PF',
            pointsStanding: 'Pt.',
            rank: '',
            teamId: '',
            teamName: '',
            total: 'G',
            winPercentage: 'Diff.',
            won: 'V',
            title: '',
            titleLabel: function titleLabel(id) {
              return 'GRUPPO ' + id;
            },
            toolTip: {
              titleLabel: function titleLabel() {
                return '';
              },
              lost: 'Perse',
              pointsConceded: 'Punti Subiti',
              pointsScored: 'Punti Fatti',
              pointsStanding: 'Punti',
              rank: '',
              teamId: '',
              teamName: '',
              total: 'Giocate',
              winPercentage: 'Diff. Punti',
              won: 'Vittorie',
              title: ''
            }
          },
          competitionMarkers: {
            goals: 'G',
            penalties: 'R',
            playerId: '',
            playerName: '',
            playerRole: 'Ruolo',
            playerCountry: '',
            teamId: '',
            teamName: 'Squadra',
            titleLabel: function titleLabel() {
              return '';
            },
            toolTip: {
              titleLabel: function titleLabel() {
                return '';
              },
              goals: 'Goal',
              penalties: 'Rigori'
            }
          },
          competitionRoundMatches: {
            team1: '',
            team2: '',
            firstLeg: 'Andata',
            secondLeg: 'Ritorno',
            titleLabel: function titleLabel(id) {
              var playOffLabel = {
                'Round of 32': 'Sedicesimi di finale',
                'Round of 16': 'Ottavi di finale',
                'Quarter-Finals': 'Quarti di finale',
                'Semi-Finals': 'Semifinali',
                Round: '',
                'Play-Offs': '',
                '3rd and 4th Place': 'Finale per il 3° posto',
                Final: 'Finale',
                D2: 'Gruppo D2'
              };
              return playOffLabel[id];
            },
            toolTip: {
              titleLabel: function titleLabel() {
                return '';
              }
            }
          },
          hallOfFame: {
            teamName: '',
            teamId: '',
            year: '',
            point: '',
            toolTip: {
              titleLabel: function titleLabel() {
                return '';
              },
              year: ''
            }
          },
          drivers: {
            points: 'P',
            team: '',
            teamNat: '',
            driverId: '',
            driver: '',
            driverNat: '',
            driverFirstName: '',
            driverLastName: '',
            position: '',
            toolTip: {
              points: 'Punti'
            }
          },
          players: {
            nationality: '',
            displayName: '',
            firstName: '',
            lastName: '',
            points: 'Pt.',
            rank: '',
            toolTip: {
              points: 'Punti'
            }
          },
          constructors: {
            points: 'P',
            builder: '',
            constructorId: '',
            position: '',
            toolTip: {
              points: 'Punti'
            }
          },
          teams: {
            points: 'P',
            team: '',
            teamId: '',
            position: '',
            toolTip: {
              points: 'Punti'
            }
          },
          freePractice: {
            time: '',
            team: '',
            tid: '',
            didx: '',
            driver: '',
            nat: '',
            pos: ''
          },
          superpole: {
            time: 'Tempo',
            team: '',
            tid: '',
            didx: '',
            driver: '',
            nat: '',
            pos: '',
            toolTip: {
              time: ''
            }
          },
          warmup: {
            time: 'Tempo',
            team: '',
            tid: '',
            didx: '',
            driver: '',
            nat: '',
            pos: '',
            toolTip: {
              time: ''
            }
          },
          qualification: {
            Q3: 'Q3',
            Q2: 'Q2',
            Q1: 'Q1',
            team: '',
            tid: '',
            driver: '',
            driverName: '',
            nat: '',
            pos: '',
            toolTip: {
              Q3: 'Qualificazione 1',
              Q2: 'Qualificazione 2',
              Q1: ' Qualificazione1'
            }
          },
          qualification2: {
            time: 'Tempo',
            team: '',
            tid: '',
            driver: '',
            driverName: '',
            nat: '',
            pos: '',
            toolTip: {}
          },
          raceLive: {
            pitstops: 'Pit Stop',
            time: 'Tempo',
            laps: 'Giri',
            status: 'Status',
            team: '',
            tid: '',
            didx: '',
            driver: '',
            nat: '',
            pos: '',
            titleLabel: function titleLabel(laps) {
              return laps;
            },
            toolTip: {
              pitstops: '',
              laps: '',
              status: ''
            }
          },
          sprintraceLive: {
            pitstops: 'Pit Stop',
            time: 'Tempo',
            laps: 'Giri',
            status: 'Status',
            team: '',
            tid: '',
            didx: '',
            driver: '',
            nat: '',
            pos: '',
            titleLabel: function titleLabel(laps) {
              return laps;
            },
            toolTip: {
              pitstops: '',
              laps: '',
              status: ''
            }
          },
          sprintqualiLive: {
            pitstops: 'Pit Stop',
            time: 'Tempo',
            laps: 'Giri',
            status: 'Status',
            team: '',
            tid: '',
            didx: '',
            driver: '',
            nat: '',
            pos: '',
            titleLabel: function titleLabel(laps) {
              return laps;
            },
            toolTip: {
              pitstops: '',
              laps: '',
              status: ''
            }
          },
          race1Live: {
            pitstops: 'Pit Stop',
            laps: 'Giri',
            status: 'Status',
            team: '',
            tid: '',
            didx: '',
            driver: '',
            nat: '',
            pos: '',
            titleLabel: function titleLabel(laps) {
              return laps;
            },
            toolTip: {
              pitstops: '',
              laps: '',
              status: ''
            }
          },
          race_superpoleLive: {
            pitstops: 'Pit Stop',
            laps: 'Giri',
            status: 'Status',
            team: '',
            tid: '',
            didx: '',
            driver: '',
            nat: '',
            pos: '',
            titleLabel: function titleLabel(laps) {
              return laps;
            },
            toolTip: {
              pitstops: '',
              laps: '',
              status: ''
            }
          },
          race2Live: {
            pitstops: 'Pit Stop',
            laps: 'Giri',
            status: 'Status',
            team: '',
            tid: '',
            didx: '',
            driver: '',
            nat: '',
            pos: '',
            titleLabel: function titleLabel(laps) {
              return laps;
            },
            toolTip: {
              pitstops: '',
              laps: '',
              status: ''
            }
          },
          raceEnded: {
            pitstops: 'PS',
            time: 'Tempo',
            points: 'P',
            team: '',
            tid: '',
            didx: '',
            driver: '',
            nat: '',
            pos: '',
            toolTip: {
              pitstops: 'Pit Stop',
              points: 'Punti',
              time: ''
            }
          },
          sprintraceEnded: {
            pitstops: 'PS',
            time: 'Tempo',
            points: 'P',
            team: '',
            tid: '',
            didx: '',
            driver: '',
            nat: '',
            pos: '',
            toolTip: {
              pitstops: 'Pit Stop',
              points: 'Punti',
              time: ''
            }
          },
          sprintqualiEnded: {
            pitstops: 'PS',
            time: 'Tempo',
            points: 'P',
            team: '',
            tid: '',
            didx: '',
            driver: '',
            nat: '',
            pos: '',
            toolTip: {
              pitstops: 'Pit Stop',
              points: 'Punti',
              time: ''
            }
          },
          race1Ended: {
            pitstops: 'PS',
            time: 'Tempo',
            points: 'P',
            team: '',
            tid: '',
            didx: '',
            driver: '',
            nat: '',
            pos: '',
            toolTip: {
              pitstops: 'Pit Stop',
              points: 'Punti',
              time: ''
            }
          },
          race_superpoleEnded: {
            pitstops: 'PS',
            time: 'Tempo',
            points: 'P',
            team: '',
            tid: '',
            didx: '',
            driver: '',
            nat: '',
            pos: '',
            toolTip: {
              pitstops: 'Pit Stop',
              points: 'Punti',
              time: ''
            }
          },
          race2Ended: {
            pitstops: 'PS',
            time: 'Tempo',
            points: 'P',
            team: '',
            tid: '',
            didx: '',
            driver: '',
            nat: '',
            pos: '',
            toolTip: {
              pitstops: 'Pit Stop',
              points: 'Punti',
              time: ''
            }
          },
          squad: {
            playerId: '',
            teamId: '',
            playerName: 'Nome giocatore',
            playerJersey: '',
            playerRole: 'Ruolo',
            playerBirthDate: '',
            toolTip: {
              titleLabel: function titleLabel() {
                return '';
              },
              playerId: '',
              teamId: '',
              playerName: 'Nome giocatore',
              playerJersey: '',
              playerRole: 'Ruolo',
              playerBirthDate: ''
            }
          }
        }
      },
      statistics: {
        newspapers: {
          gazzetta: 'La Gazzetta dello Sport',
          corriere: 'Corriere.it',
          fcinter: 'FC Inter 1908',
          forzaroma: 'Forzaroma.info',
          calcionapoli1926: 'Calcio Napoli 1926'
        },
        statsInCompetition: {
          won: 'partite vinte',
          lost: 'sconfitte',
          drawn: 'pareggi',
          goalsMade: 'gol segnati',
          goalsConceded: 'gol subiti',
          played: 'gol/partita'
        },
        lastMatches: {
          last: 'Ultime 5 partite',
          versus: 'Testa a testa',
          form: 'Forma',
          allMatches: 'Tutte le partite',
          headToHead: 'Sfide in',
          played: 'Giocate',
          draw: 'Pareggiate'
        },
        barLabels: {
          possession_percentage: {
            label: 'Possesso Palla',
            isPercentage: true,
            isInside: true
          },
          shots: {
            label: 'Tiri in porta',
            isPercentage: false,
            isInside: true
          },
          shots_saved: {
            label: 'Tiri respinti',
            isPercentage: false,
            isInside: true
          },
          offsides: {
            label: 'Fuorigioco',
            isPercentage: false,
            isInside: true
          },
          corners: {
            label: 'Corner',
            isPercentage: false,
            isInside: true
          },
          crosses: {
            label: 'Cross',
            isPercentage: false,
            isInside: true
          },
          dribblings: {
            label: 'Dribbling',
            isPercentage: false,
            isInside: true
          },
          fouls: {
            label: 'Falli subiti',
            isPercentage: false,
            isInside: true
          },
          yellow_cards: {
            label: 'Ammonizioni',
            isPercentage: false,
            isInside: true
          },
          red_cards: {
            label: 'Espulsioni',
            isPercentage: false,
            isInside: true
          },
          lastFive: {
            label: 'Vinte',
            isPercentage: false,
            isInside: false
          },
          pointsScored: {
            label: 'Punti segnati',
            isPercentage: false,
            isInside: true
          },
          fieldGoalsMade: {
            label: 'Tiri realizzati',
            isPercentage: false,
            isInside: true
          },
          fieldGoalsAttempts: {
            label: 'Tiri totali',
            isPercentage: false,
            isInside: true
          },
          s2PointMade: {
            label: 'Tiri da 2',
            isPercentage: false,
            isInside: true
          },
          s2PointAttempts: {
            label: 'Tentativi tiri da 2',
            isPercentage: false,
            isInside: true
          },
          s3PointMade: {
            label: 'Tiri da 3',
            isPercentage: false,
            isInside: true
          },
          s3PointAttempts: {
            label: 'Tentativi tiri da 3',
            isPercentage: false,
            isInside: true
          },
          freeThrowsMade: {
            label: 'Tiri liberi',
            isPercentage: false,
            isInside: true
          },
          freeThrowsAttempts: {
            label: 'Tentativi tiri liberi',
            isPercentage: false,
            isInside: true
          },
          offensiveRebounds: {
            label: 'Rimbalzi Offensivi',
            isPercentage: false,
            isInside: true
          },
          defensiveRebounds: {
            label: 'Rimbalzi Difensivi',
            isPercentage: false,
            isInside: true
          },
          totalRebounds: {
            label: 'Rimbalzi Totali',
            isPercentage: false,
            isInside: true
          },
          personalFouls: {
            label: 'Falli Fatti',
            isPercentage: false,
            isInside: true
          },
          assists: {
            label: 'Assist',
            isPercentage: false,
            isInside: true
          },
          steals: {
            label: 'Palle Rubate',
            isPercentage: false,
            isInside: true
          },
          blocks: {
            label: 'Stoppate',
            isPercentage: false,
            isInside: true
          }

        },
        player: {
          age: 'Età',
          height: 'Altezza',
          weight: 'Peso',
          foot: 'Piede preferito',
          goal: 'gol realizzati',
          assist: 'assist',
          penalty: 'rigori realizzati',
          games: 'partite giocate',
          subOff: 'da titolare',
          subOn: 'da subentrato',
          minPlayed: 'minuti giocati',
          yellowCards: 'ammonizioni',
          redCards: 'espulsioni',
          voteMean: 'media voto',
          magicVoteMean: 'media Magic voto',
          magicCredits: 'Magic crediti'
        }
      },
      header: {
        21: 'Serie A',
        105: 'Serie B',
        128: 'Copa America',
        5: 'Champions League',
        6: 'Europa League',
        1125: 'Conference League',
        22: 'Bundesliga',
        23: 'Liga',
        8: 'Premier League',
        24: 'Ligue 1',
        3: 'Euro 2024',
        352: 'Europei U21',
        383: 'Europei U19',
        4: 'Mondiali',
        1277: 'Mondiale per Club',
        408: 'Mondiali Femminili',
        616: 'Europei Femminili',
        941: 'Nations League',
        259: 'Coppa Italia',
        173: 'Super Coppa Italiana',
        174: 'Super Coppa Europea',
        558: 'Clausura Cile',
        9: 'Eredivisie',
        135: 'Swiss Super League',
        199: 'Apertura Messico',
        363: 'Brasileirao',
        371: 'Apertura Colombia',
        99: 'LPFP Portogallo',
        115: 'Super Lig Turchia',
        724: 'Primera Division',
        589: 'Clausura Colombia',
        129: 'Premier Liga Russa',
        367: 'Primera Division Uruguay (Apertura)',
        588: 'Primera Division Uruguay (Clausura)',
        370: 'Apertura Cile',
        113: 'Greece Superleague',
        14: 'Premier League Scozia',
        116: 'Prva HNL Croazia',
        88: 'Amichevole',
        standings: 'Posizione in classifica: #',
        motorsport: {
          1: 'Formula 1',
          3: 'Moto GP',
          4: 'Moto 2',
          5: 'Moto 3'
        }
      },
      clubInfo: {
        society: 'Societ&agrave;',
        management: 'Dirigenza',
        founded: 'Anno fondazione',
        stadium: 'Stadio',
        place: 'Sede',
        staff: 'Staff tecnico',
        honours: 'Albo d\'oro',
        'Assistant Manager': 'Allenatore in 2&ordf;',
        Manager: 'Allenatore',
        'Organisation and technical': 'Direttore Area Tecnica',
        'Director, Head of Board': 'Direttore Generale',
        President: 'Presidente',
        'Fitness Trainer': 'Massaggiatore',
        'Team Manager': 'Direttore Sportivo',
        'Athletic trainer': 'Preparatore atletico'
      },
      cupstandings: {
        forward: 'Avanti',
        back: 'Indietro',
        toolTip: {
          goals: 'Goal',
          penalties: 'Rigori'
        }
      },
      liveHubLink: {
        local: '#',
        development: '#',
        stag: '/risultati-live/',
        production: '/risultati-live/'
      },
      gazzanetLiveHubLink: {
        local: '#',
        development: '#',
        stag: '/competizioni-calcio/risultati-live/',
        production: '/competizioni-calcio/risultati-live/'
      },
      calendarLink: {
        local: '#',
        development: '#',
        stag: '/calcio/',
        production: '/calcio/'
      },
      gazzanetCalendarLink: {
        local: '#',
        development: '#',
        stag: '/competizioni-calcio/',
        production: '/competizioni-calcio/'
      },
      raceCalendarLink: {
        local: '#',
        development: '#',
        stag: '/motori/',
        production: '/motori/'
      },
      standingsLink: {
        local: '#',
        development: '#',
        stag: '/calcio/',
        production: '/calcio/'
      },
      gazzanetStandingsLink: {
        local: '#',
        development: '#',
        stag: '/competizioni-calcio/',
        production: '/competizioni-calcio/'
      },
      raceStandingsLink: {
        local: '#',
        development: '#',
        stag: '/motori/',
        production: '/motori/'
      },
      competitionLink: {
        21: 'serie-a',
        105: 'serie-b',
        1105: 'serie-b-playoff',
        128: 'copa-america',
        5: 'champions-league',
        6: 'europa-league',
        1125: 'conference-league',
        22: 'bundesliga',
        23: 'liga',
        8: 'premier-league',
        24: 'ligue-1',
        3: 'europei',
        352: 'europei-u21',
        383: 'europei-u19',
        4: 'mondiali',
        408: 'mondiali-femminili',
        616: 'nazionale-femminile',
        941: 'nations-league',
        259: 'coppa-italia',
        173: 'supercoppaitaliana',
        174: 'supercoppaeuropea',
        88: 'amichevoli',
        558: 'clausura-cile',
        9: 'eredivisie',
        135: 'swiss-super-league',
        199: 'apertura-mexico',
        363: 'brasileirao',
        371: 'apertura-colombia',
        99: 'lpfp_portuguese-liga',
        115: 'tff-super-lig',
        724: 'primera-division-argentina',
        589: 'clausura-colombia',
        129: 'russian-premier-liga',
        367: 'primera-division-uruguay-apertura',
        588: 'primera-division-uruguay-clausura',
        370: 'apertura-cile',
        113: 'superleague-ellada',
        14: 'scottish-premier-league',
        116: 'prva-nhl',
        '6C': 'F1',
        1277: 'coppa-mondo-club',
        335: 'coppa-mondo-club-2023',
        34: 'amichevole',
        1166: 'finale-conmebol-uefa'
      },
      raceCompetitionLink: {
        1: 'f1',
        2: 'superbike',
        3: 'motogp',
        4: 'moto2',
        5: 'moto3'
      },
      basketCompetitionLink: {
        1: 'serie-a-maschile',
        2: 'serie-a-femminile',
        3: 'nba',
        4: 'lituania',
        5: 'spagna',
        6: 'mondiali',
        7: 'europei'
      },
      skiCompetitionLink: {
        1: 'coppa-mondo-sci-maschile',
        2: 'coppa-mondo-sci-femminile'
      },
      rugbyCompetitionLink: {
        209: '6-nazioni',
        212: 'top12'
      },
      volleyCompetitionLink: {
        2: 'superlega',
        3: 'serie-a1-femminile'
      },
      cyclingCompetitionLink: {
        7100: 'tour-de-france',
        7101: 'giro-d-italia',
        7102: 'vuelta',
        7107: 'world-cup',
        90014: 'santos-tour-down-under',
        90030: 'paris-roubaix',
        90031: 'criterium-du-dauphine',
        90032: 'paris-nice',
        90033: 'tour-de-california',
        90035: 'clasica-de-san-sebastian',
        90036: 'tour-de-polonia',
        90050: 'cadel-evans-great-ocean-road-race',
        90051: 'uae-tour',
        90053: 'strade-bianche',
        90052: 'omloop-het-nieuwsblad',
        90054: 'tirreno-adriatico',
        90055: 'milan-sanremo',
        90056: 'volta-ciclista-a-catalunya',
        90057: 'e3-harelbeke',
        90058: 'gent-wevelgem',
        90059: 'dwars-door-vlaanderen',
        90060: 'tour-de-flandes',
        90061: 'vuelta-al-pais-vasco',
        90062: 'amstel-gold-race',
        90063: 'la-fleche-wallonne',
        90064: 'liege-bastogne-liege',
        90065: 'tour-de-romandie',
        90066: 'eschborn-frankfurt',
        90067: 'tour-de-suiza',
        90068: 'ridelondon-surrey-classic',
        90069: 'binck-bank-tour',
        90070: 'euroeyes-cyclassics-hamburg',
        90071: 'bretagne-classic-ouest-france',
        90072: 'grand-prix-cycliste-de-quebec',
        90073: 'grand-prix-cycliste-de-montreal',
        90074: 'presidential-cycling-tour-of-turkey',
        90075: 'giro-di-lombardia',
        90076: 'tour-of-guangxi',
        90115: 'driedaagse-brugge-de-panne'
      },
      cyclingCompetitionLabel: {
        7100: 'Tour de France',
        7101: "Giro d'Italia",
        7102: 'Vuelta',
        7107: 'Mundial Yorkshire',
        90014: 'Santos Tour Down Under',
        90030: 'Parigi-Roubaix',
        90031: 'Critérium du Dauphiné',
        90032: 'Parigi-Nizza',
        90033: 'Tour of California',
        90035: 'Clásica San Sebastián',
        90036: 'Giro di Polonia',
        90050: 'Cadel Evans Great Ocean Road Race',
        90051: 'UAE Tour',
        90052: 'Omloop Het Nieuwsblad',
        90053: 'Strade Bianche',
        90054: 'Tirreno-Adriatico',
        90055: 'Milano-Sanremo',
        90056: 'Volta Ciclista a Catalunya',
        90057: 'E3 Harelbeke',
        90058: 'Gand-Wevelgem',
        90059: 'Dwars door Vlaanderen',
        90060: 'Giro delle Fiandre',
        90061: 'Vuelta al País Vasco',
        90062: 'Amstel Gold Race',
        90063: 'Freccia Vallone',
        90064: 'Liegi-Bastogne-Liegi',
        90065: 'Tour de Romandia',
        90066: 'Eschborn-Frankfurt',
        90067: 'Tour of Suisse',
        90068: 'RideLondon-Surrey Classic',
        90069: 'Binck Bank Tour',
        90070: 'EuroEyes Cyclassics Hamburg',
        90071: 'Bretagne Classic Ouest-France',
        90072: 'Grand Prix Cycliste de Québec',
        90073: 'Grand Prix Cycliste de Montréal',
        90074: 'Presidential Cycling Tour of Turkey',
        90075: 'Giro di Lombardia',
        90076: 'Tour of Guangxi',
        90115: 'Driedaagse Brugge-De Panne'
      },
      sportsName: {
        1: 'calcio',
        '6C': 'automobilismo',
        '6M': 'motociclismo',
        8: 'tennis',
        3: 'basket'
      },
      raceSolrName: {
        1: 'f1',
        2: 'superbike',
        3: 'moto-gp',
        4: 'moto-2',
        5: 'moto-3'
      },
      widgets: {
        cols: {
          competitionTeams: {
            teamName: '',
            teamId: '',
            drawn: 'N',
            englishMean: 'MI',
            form: 'Forma',
            goalsConceded: 'Gs',
            goalsMade: 'Gf',
            lost: 'P',
            played: 'G',
            points: 'Pt.',
            position: '',
            startingPosition: '',
            won: 'V',
            titleLabel: function titleLabel() {
              return 'Squadra';
            },
            toolTip: {
              titleLabel: function titleLabel() {
                return '';
              },
              drawn: 'Pareggi',
              englishMean: 'Media Inglese',
              goalsConceded: 'Goal subiti',
              goalsMade: 'Goal fatti',
              lost: 'Perse',
              played: 'Giocate',
              points: 'Punti',
              position: '',
              won: 'Vittorie'
            }
          },
          competitionMarkers: {
            goals: 'G',
            penalties: 'R',
            playerId: '',
            playerName: '',
            playerRole: 'Ruolo',
            playerCountry: '',
            teamId: '',
            teamName: 'Squadra',
            titleLabel: function titleLabel() {
              return 'Giocatore';
            },
            toolTip: {
              titleLabel: function titleLabel() {
                return '';
              },
              goals: 'Goal',
              penalties: 'Rigori'
            }
          },
          rugbyStandings: {
            teamName: '',
            teamId: '',
            drawn: 'N',
            losingBonus: 'LB',
            triesBonus: 'TB',
            triesFor: 'Mf',
            triesAgainst: 'Ms',
            lost: 'P',
            played: 'G',
            points: 'Pt.',
            rank: '',
            won: 'V',
            pointsDiff: '+/-',
            titleLabel: function titleLabel() {
              return 'GiocSquadraSquadraatore';
            },
            toolTip: {
              titleLabel: function titleLabel() {
                return '';
              },
              drawn: 'Pareggi',
              losingBonus: 'Losing Bonus',
              triesBonus: 'Tries Bonus',
              lost: 'Perse',
              played: 'Giocate',
              points: 'Punti',
              won: 'Vittorie',
              pointsDiff: 'Differenza punti'
            }
          }
        },
        worldCupCorriere: {
          standingLink: 'https://www.corriere.it/sport/calcio/mondiali/classifica/',
          calendarLink: 'https://www.corriere.it/sport/calcio/mondiali/calendario-risultati/',
          timing: {
            'Full Time': 'Finita',
            FINISHED: 'Finita',
            'First Half': 'I Tempo',
            'Half Time': 'Fine I Tempo',
            'Second Half': 'II Tempo',
            'Pre Match': 'Ore',
            FullTime: 'Finita',
            FullTime90: 'Fine II Tempo',
            FullTimePens: 'Fine II TS',
            ShootOut: 'Rigori',
            FirstHalf: 'I Tempo',
            HalfTime: 'Fine I Tempo',
            SecondHalf: 'II Tempo',
            PreMatch: 'Ore',
            ExtraFirstHalf: 'I Tempo suppl.',
            ExtraHalfTime: 'Fine I TS',
            ExtraSecondHalf: 'II Tempo suppl.',
            Abandoned: 'Abbandonato',
            Postponed: 'Rinviata',
            Notplayed: 'non disputata',
            Delayed: 'Posticipato',
            Suspended: 'Sospeso',
            Cancelled: 'Cancellato'
          },
          phases: {
            groups: 'Gironi',
            'round-of-16': 'Ottavi',
            'quarter-finals': 'Quarti',
            'semi-finals': 'Semifin.',
            '3rd-and-4th-place': '3°/4° posto',
            final: 'Finale'
          }
        }
      },
      synthesis: {
        desktop: {
          'Full Time': 'Fine',
          FINISHED: 'Fine',
          'First Half': '1°T',
          'Half Time': 'Fine 1°T',
          'Second Half': '2°T',
          'Pre Match': '',
          FullTime: 'Fine',
          FullTime90: 'Fine 2° Tempo',
          FullTimePens: 'Fine 2° TS',
          FirstHalf: 'Primo Tempo',
          HalfTime: 'Finisce il 1°T',
          SecondHalf: 'Secondo Tempo',
          PreMatch: '',
          ExtraFirstHalf: '1° TS',
          ExtraHalfTime: 'Fine 1°TS',
          ExtraSecondHalf: '2° TS',
          ShootOut: 'Calci di rigore',
          Abandoned: 'Abbandonato',
          Postponed: 'Rinviata',
          NOTPLAYED: 'non disputata',
          Delayed: 'Posticipato',
          Suspended: 'Sospeso',
          Cancelled: 'Cancellato',
          Live: 'Live',
          start: 'Inizia il',
          lineups: 'Formazioni',
          yellow_card: 'Ammonito',
          red_card: 'Espulso',
          second_yellow_red_card: 'Espulso per doppio giallo',
          goal: 'Gol',
          end: 'Finisce',
          postGame: 'partita',
          player_on: 'Entra',
          player_off: 'Esce',
          post_right: 'sul Palo',
          post_left: 'sul Palo',
          post: 'sul Palo',
          post_high: 'sulla Traversa',
          own_goal: 'Autorete',
          penalty_scored: 'Gol su rigore',
          penalty_saved: 'Parata',
          hit_woodwork: 'Rigore sbagliato',
          penalty_missed: 'Rigore fuori',
          close_left: 'sfiora il palo',
          close_right: 'sfiora il palo',
          close_high: 'sfiora la traversa',
          close_high_left: "sfiora l'incrocio",
          close_high_right: "sfiora l'incrocio",
          'hit_woodwork post_right': 'Rigore sul palo',
          'hit_woodwork post_left': 'Rigore sul palo',
          'hit_woodwork post_high': 'Rigore sulla traversa',
          //'penalty_missed close_high': 'Rigore sfiora la traversa',
          'start FirstHalf': 'Inizia il Primo Tempo',
          'end postGame': 'Finisce la Partita'
        },
        mobile: {
          second_yellow_red_card: 'Espulso'
        }
      }
    }
  },
  routes: {
    hublive: {
      local: function local() {
        return '/';
      },
      development: function development() {
        return '/';
      },
      stag: function stag() {
        return '/risultati-live/';
      },
      production: function production() {
        return '/risultati-live/';
      }
    },
    favourites: {
      local: function local() {
        return '/favourites';
      },
      development: function development() {
        return '/favourites';
      },
      stag: function stag() {
        return '/risultati-live/preferiti/';
      },
      production: function production() {
        return '/risultati-live/preferiti/';
      }
    },
    hubliveCorriere: {
      local: function local() {
        return '/';
      },
      development: function development() {
        return '/';
      },
      stag: function stag() {
        return '/sport/risultati-live/';
      },
      production: function production() {
        return '/sport/risultati-live/';
      }
    },
    favouritesCorriere: {
      local: function local() {
        return '/favourites';
      },
      development: function development() {
        return '/favourites';
      },
      stag: function stag() {
        return '/sport/risultati-live/preferiti/';
      },
      production: function production() {
        return '/sport/risultati-live/preferiti/';
      }
    },
    hubliveGazzanet: {
      local: function local() {
        return '/';
      },
      development: function development() {
        return '/';
      },
      stag: function stag() {
        return '/competizioni-calcio/risultati-live/';
      },
      production: function production() {
        return '/competizioni-calcio/risultati-live/';
      }
    },
    favouritesGazzanet: {
      local: function local() {
        return '/favourites';
      },
      development: function development() {
        return '/favourites';
      },
      stag: function stag() {
        return '/competizioni-calcio/risultati-live/preferiti/';
      },
      production: function production() {
        return '/competizioni-calcio/risultati-live/preferiti/';
      }
    },
    calendar: {
      local: function local() {
        return '/calendar';
      },
      development: function development() {
        return '/calendar';
      },
      stag: function stag() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      },
      production: function production() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      }
    },
    cupcalendar: {
      local: function local() {
        return '/cupcalendar';
      },
      development: function development() {
        return '/cupcalendar';
      },
      stag: function stag() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      },
      production: function production() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      }
    },
    motorsportcalendar: {
      local: function local() {
        return '/motorsportcalendar';
      },
      development: function development() {
        return '/motorsportcalendar';
      },
      stag: function stag() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      },
      production: function production() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      }
    },
    tenniscalendar: {
      local: function local() {
        return '/tenniscalendar';
      },
      development: function development() {
        return '/tenniscalendar';
      },
      stag: function stag() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      },
      production: function production() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      }
    },
    cyclecalendar: {
      local: function local() {
        return '/cyclecalendar';
      },
      development: function development() {
        return '/cyclecalendar';
      },
      stag: function stag() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      },
      production: function production() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      }
    },
    volleycalendar: {
      local: function local() {
        return '/volleycalendar';
      },
      development: function development() {
        return '/volleycalendar';
      },
      stag: function stag() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      },
      production: function production() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      }
    },
    volleycalendarchampionship: {
      local: function local() {
        return '/volleycalendarchampionship';
      },
      development: function development() {
        return '/volleycalendarchampionship';
      },
      stag: function stag() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      },
      production: function production() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      }
    },
    nbacalendar: {
      local: function local() {
        return '/nbacalendar';
      },
      development: function development() {
        return '/nbacalendar';
      },
      stag: function stag() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      },
      production: function production() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      }
    },
    basketcalendarchampionship: {
      local: function local() {
        return '/basketcalendarchampionship';
      },
      development: function development() {
        return '/basketcalendarchampionship';
      },
      stag: function stag() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      },
      production: function production() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      }
    },
    rugbycalendar: {
      local: function local() {
        return '/rugbycalendar';
      },
      development: function development() {
        return '/rugbycalendar';
      },
      stag: function stag() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      },
      production: function production() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      }
    },
    topscorers: {
      local: function local() {
        return '/topscorers';
      },
      development: function development() {
        return '/topscorers';
      },
      stag: function stag() {
        return '/MatchCenter/topscorers/';
      },
      production: function production() {
        return '/test/matchcenter/topscorers/';
      }
    },
    standings: {
      local: function local() {
        return '/standings';
      },
      development: function development() {
        return '/standings';
      },
      stag: function stag() {
        return '/MatchCenter/standings/';
      },
      production: function production() {
        return '/test/matchcenter/standings/';
      }
    },
    cupstandings: {
      local: function local() {
        return '/cupstandings';
      },
      development: function development() {
        return '/cupstandings';
      },
      stag: function stag() {
        return '/MatchCenter/cupStandings/';
      },
      production: function production() {
        return '/test/matchcenter/cupStandings/';
      }
    },
    driverstandings: {
      local: function local() {
        return '/driverstandings';
      },
      development: function development() {
        return '/driverstandings';
      },
      stag: function stag() {
        return '/MatchCenter/driverstandings/';
      },
      production: function production() {
        return '/test/matchcenter/driverstandings/';
      }
    },
    constructorstandings: {
      local: function local() {
        return '/constructorstandings';
      },
      development: function development() {
        return '/constructorstandings';
      },
      stag: function stag() {
        return '/MatchCenter/constructorstandings/';
      },
      production: function production() {
        return '/test/matchcenter/constructorstandings/';
      }
    },
    halloffame: {
      local: function local() {
        return '/halloffame';
      },
      development: function development() {
        return '/halloffame';
      },
      stag: function stag() {
        return '/MatchCenter/halloffame/';
      },
      production: function production() {
        return '/test/matchcenter/halloffame/';
      }
    },
    cyclinghalloffame: {
      local: function local() {
        return '/cyclinghalloffame';
      },
      development: function development() {
        return '/cyclinghalloffame';
      },
      stag: function stag() {
        return '/MatchCenter/cyclinghalloffame/';
      },
      production: function production() {
        return '/test/matchcenter/cyclinghalloffame/';
      }
    },
    tennisranking: {
      local: function local() {
        return '/tennisranking';
      },
      development: function development() {
        return '/tennisranking';
      },
      stag: function stag() {
        return '/MatchCenter/tennisranking/';
      },
      production: function production() {
        return '/test/matchcenter/tennisranking/';
      }
    },
    cyclingstandings: {
      local: function local() {
        return '/cyclingstandings';
      },
      development: function development() {
        return '/cyclingstandings';
      },
      stag: function stag() {
        return '/MatchCenter/cyclingstandings/';
      },
      production: function production() {
        return '/test/matchcenter/cyclingstandings/';
      }
    },
    cyclingstage: {
      local: function local() {
        return '/cyclingstage';
      },
      development: function development() {
        return '/cyclingstage';
      },
      stag: function stag() {
        return '/MatchCenter/cyclingstage/';
      },
      production: function production() {
        return '/test/matchcenter/cyclingstage/';
      }
    },
    skistandings: {
      local: function local() {
        return '/skistandings';
      },
      development: function development() {
        return '/skistandings';
      },
      stag: function stag() {
        return '/MatchCenter/skistandings/';
      },
      production: function production() {
        return '/test/matchcenter/skistandings/';
      }
    },
    skistage: {
      local: function local() {
        return '/skistage';
      },
      development: function development() {
        return '/skistage';
      },
      stag: function stag() {
        return '/MatchCenter/skistage/';
      },
      production: function production() {
        return '/test/matchcenter/skistage/';
      }
    },
    skicalendar: {
      local: function local() {
        return '/skicalendar';
      },
      development: function development() {
        return '/skicalendar';
      },
      stag: function stag() {
        return '/MatchCenter/skicalendar/';
      },
      production: function production() {
        return '/test/matchcenter/skicalendar/';
      }
    },
    ucicalendar: {
      local: function local() {
        return '/ucicalendar';
      },
      development: function development() {
        return '/ucicalendar';
      },
      stag: function stag() {
        return '/MatchCenter/ucicalendar/';
      },
      production: function production() {
        return '/test/matchcenter/ucicalendar/';
      }
    },
    matchPage: {
      local: function local() {
        return '/';
      },
      development: function development() {
        return '/';
      },
      stag: function stag() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      },
      production: function production() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      }
    },
    teamPage: {
      local: function local() {
        return '/';
      },
      development: function development() {
        return '/';
      },
      stag: function stag() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      },
      production: function production() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      }
    },
    playerPage: {
      local: function local() {
        return '/';
      },
      development: function development() {
        return '/';
      },
      stag: function stag() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      },
      production: function production() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      }
    },
    volleystandings: {
      local: function local() {
        return '/volleystandings';
      },
      development: function development() {
        return '/volleystandings';
      },
      stag: function stag() {
        return '/MatchCenter/volleystandings/';
      },
      production: function production() {
        return '/test/matchcenter/volleystandings/';
      }
    },
    basketstandings: {
      local: function local() {
        return '/basketstandings';
      },
      development: function development() {
        return '/basketstandings';
      },
      stag: function stag() {
        return '/MatchCenter/basketstandings/';
      },
      production: function production() {
        return '/test/matchcenter/basketstandings/';
      }
    },
    rugbystandings: {
      local: function local() {
        return '/rugbystandings';
      },
      development: function development() {
        return '/rugbystandings';
      },
      stag: function stag() {
        return '/MatchCenter/rugbystandings/';
      },
      production: function production() {
        return '/test/matchcenter/rugbystandings/';
      }
    },
    uefastandings: {
      local: function local() {
        return '/uefastandings';
      },
      development: function development() {
        return '/uefastandings';
      },
      stag: function stag() {
        return '/MatchCenter/uefastandings/';
      },
      production: function production() {
        return '/test/matchcenter/uefastandings/';
      }
    },
    uefaplayoff: {
      local: function local() {
        return '/uefaplayoff';
      },
      development: function development() {
        return '/uefaplayoff';
      },
      stag: function stag() {
        return '/MatchCenter/uefaplayoff/';
      },
      production: function production() {
        return '/test/matchcenter/uefaplayoff/';
      }
    }
  },
  tables: {
    colsPosition: {
      competitionTeams: {
        teamName: 3,
        drawn: 8,
        englishMean: 12,
        form: 13,
        goalsConceded: 11,
        goalsMade: 10,
        lost: 9,
        played: 6,
        points: 5,
        position: 1,
        startingPosition: 4,
        won: 7,
        teamId: 2,
        title: 0
      },
      statsInCompetition: {
        won: 0,
        lost: 1,
        drawn: 2,
        goalsMade: 3,
        goalsConceded: 4,
        played: 5
      },
      squad: {
        playerJersey: 1,
        playerId: 0,
        playerName: 2,
        playerRole: 3
      },
      competitionMarkers: {
        goals: 7,
        penalties: 8,
        playerId: 1,
        playerName: 3,
        playerRole: 6,
        playerCountry: 2,
        teamId: 4,
        teamName: 5
      },
      competitionRoundMatches: {
        secondLeg: 4,
        firstLeg: 3,
        team2: 2,
        team1: 1,
        title: 0
      },
      hallOfFame: {
        teamName: 2,
        teamId: 1,
        year: 0,
        point: 3
      },
      drivers: {
        points: 6,
        team: 5,
        teamId: 4,
        driver: 2,
        driverNat: 1,
        driverLastName: 3,
        position: 0
      },
      players: {
        nationality: 1,
        displayName: 4,
        firstName: 3,
        lastName: 2,
        points: 5,
        rank: 0
      },
      constructors: {
        points: 3,
        builder: 2,
        constructorId: 1,
        position: 0
      },
      freePractice: {
        time: 5,
        tid: 3,
        team: 4,
        driver: 2,
        nat: 1,
        pos: 0
      },
      superpole: {
        time: 5,
        tid: 3,
        team: 4,
        driver: 2,
        nat: 1,
        pos: 0
      },
      warmup: {
        time: 5,
        tid: 3,
        team: 4,
        driverLastName: 2,
        driver: 2,
        nat: 1,
        pos: 0
      },
      qualification: {
        Q3: 6,
        Q2: 7,
        Q1: 8,
        driverLastName: 5,
        team: 4,
        tid: 3,
        driver: 2,
        nat: 1,
        pos: 0
      },
      qualification2: {
        time: 6,
        driverLastName: 5,
        team: 4,
        tid: 3,
        driver: 2,
        nat: 1,
        pos: 0
      },
      raceLive: {
        pitstops: 9,
        laps: 8,
        status: 7,
        driverLastName: 6,
        team: 5,
        tid: 4,
        driver: 3,
        nat: 2,
        pos: 1,
        title: 0
      },
      sprintraceLive: {
        pitstops: 9,
        laps: 8,
        status: 7,
        driverLastName: 6,
        team: 5,
        tid: 4,
        driver: 3,
        nat: 2,
        pos: 1,
        title: 0
      },
      race1Live: {
        pitstops: 9,
        laps: 8,
        status: 7,
        driverLastName: 6,
        team: 5,
        tid: 4,
        driver: 3,
        nat: 2,
        pos: 1,
        title: 0
      },
      race_superpoleLive: {
        pitstops: 9,
        laps: 8,
        status: 7,
        driverLastName: 6,
        team: 5,
        tid: 4,
        driver: 3,
        nat: 2,
        pos: 1,
        title: 0
      },
      race2Live: {
        pitstops: 9,
        laps: 8,
        status: 7,
        driverLastName: 6,
        team: 5,
        tid: 4,
        driver: 3,
        nat: 2,
        pos: 1,
        title: 0
      },
      raceEnded: {
        points: 9,
        pitstops: 8,
        time: 7,
        driverLastName: 6,
        team: 5,
        tid: 4,
        driver: 3,
        nat: 2,
        pos: 1
      },
      sprintraceEnded: {
        points: 9,
        pitstops: 8,
        time: 7,
        driverLastName: 6,
        team: 5,
        tid: 4,
        driver: 3,
        nat: 2,
        pos: 1
      },
      sprintqualiEnded: {
        points: 9,
        pitstops: 8,
        time: 7,
        driverLastName: 6,
        team: 5,
        tid: 4,
        driver: 3,
        nat: 2,
        pos: 1
      },
      race1Ended: {
        points: 9,
        pitstops: 8,
        time: 7,
        driverLastName: 6,
        team: 5,
        tid: 4,
        driver: 3,
        nat: 2,
        pos: 1
      },
      race_superpoleEnded: {
        points: 9,
        pitstops: 8,
        time: 7,
        driverLastName: 6,
        team: 5,
        tid: 4,
        driver: 3,
        nat: 2,
        pos: 1
      },
      race2Ended: {
        points: 9,
        pitstops: 8,
        time: 7,
        driverLastName: 6,
        team: 5,
        tid: 4,
        driver: 3,
        nat: 2,
        pos: 1
      },
      teams: {
        points: 3,
        team: 2,
        teamId: 1,
        position: 0
      },
      standingTeams: {
        teamOfficialName: 3,
        drawn: 7,
        setsAgainst: 10,
        setsPro: 9,
        matchesLost: 8,
        matchesTotal: 5,
        points: 4,
        rank: 1,
        matchesWon: 6,
        teamId: 2,
        title: 0
      },
      basketStandings: {
        lost: 7,
        pointsConceded: 9,
        pointsScored: 8,
        pointsStanding: 4,
        rank: 1,
        teamId: 2,
        teamName: 3,
        total: 5,
        winPercentage: 10,
        won: 6,
        title: 0
      }
    },
    joinedCols: {
      standingTeams: {
        leftCol: 'setsPro',
        rightCol: 'setsAgainst'
      },
      competitionTeams: {
        leftCol: 'goalsMade',
        rightCol: 'goalsConceded'
      },
      competitionMarkers: {
        leftCol: '',
        rightCol: ''
      },
      squad: {},
      drivers: {},
      constructors: {},
      freePractice: {},
      superpole: {},
      warmup: {},
      qualification: {},
      qualification2: {},
      raceLive: {},
      sprintraceLive: {},
      sprintqualiLive: {},
      race1Live: {},
      race_superpoleLive: {},
      race2Live: {},
      raceEnded: {},
      sprintraceEnded: {},
      sprintqualiEnded: {},
      race1Ended: {},
      race_superpoleEnded: {},
      race2Ended: {},
      players: {},
      basketStandings: {}
    },
    positionMarker: {
      Europa_Cup: {
        League_Position: 'lightRed',
        League_Position_Q1: 'lightPink',
        League_Position_Q2: 'lightPink',
        League_Position_Q3: 'lightPink'
      },
      Champions_League: {
        League_Winners: 'mediumBlue',
        League_Winners_Q1: 'lightBlue',
        League_Winners_Q2: 'lightBlue',
        League_Winners_Q3: 'lightBlue',
        League_Position: 'mediumBlue',
        League_Position_Q1: 'lightBlue',
        League_Position_Q2: 'lightBlue',
        League_Position_Q3: 'lightBlue'
      },
      Relegation: {
        League_Position: 'lightYellow',
        Play_Off: 'mediumGreen',
        Playoff_Relegation: 'mediumGreen'
      },
      Promotion: {
        League_Winners: 'mediumBlue',
        League_Position: 'mediumBlue',
        Play_Off: 'lightRed'
      },
      Champions_League_Qualifying: {
        League_Winners: 'mediumBlue',
        League_Winners_Q1: 'lightBlue',
        League_Winners_Q2: 'lightBlue',
        League_Winners_Q3: 'lightBlue',
        League_Position: 'mediumBlue',
        League_Position_Q1: 'lightBlue',
        League_Position_Q2: 'lightBlue',
        League_Position_Q3: 'lightBlue'
      },
      Conference_League: {
        League_Position: 'lightGreen'
      },
      Conference_League_Qualifying: {
        League_Position: 'lightGreen'
      },
      '8th Finals': {
        League_Position: 'mediumBlue'
      },
      'Play-off': {
        League_Position: 'lightRed'
      }
    },
    skipCols: {
      competitionTeams: {
        colName: ['qualification', 'englishMean', 'form'],
        isMobile: ['qualification', 'englishMean', 'form']
      },
      standingTeams: {
        colName: ['rankTotal', 'lastRank', 'countrycode', 'area', 'team', 'matchesPlayed', 'areaId', 'countryCode', 'zoneStart', 'zoneEnd', 'clubName'],
        isMobile: ['rankTotal', 'lastRank', 'countrycode', 'area', 'team', 'matchesPlayed', 'areaId', 'countryCode', 'zoneStart', 'zoneEnd', 'clubName']
      },
      competitionMarkers: {
        colName: ['playerFirstName', 'playerSecondName', 'playerBirthDate', 'playerKnowName'],
        isMobile: ['teamId', 'playerCountry', 'playerRole', 'playerFirstName', 'playerSecondName', 'playerBirthDate', 'playerKnowName']
      },
      statsInCompetition: {
        colName: ['qualification', 'englishMean', 'form', 'points', 'position', 'startingPosition', 'teamName', 'teamId'],
        isMobile: ['qualification', 'englishMean', 'form', 'points', 'position', 'startingPosition', 'teamName', 'teamId']
      },
      lastMatches: {
        colName: [''],
        isMobile: ['form']
      },
      lastFive: {},
      squad: {
        colName: ['teamId', 'playerBirthDate', 'playerKnownName'],
        isMobile: ['teamId', 'playerBirthDate', 'playerKnownName']
      },
      competitionRoundMatches: {
        colName: ['matchId', 'date', 'liveUpdated', 'status', 'timing'],
        isMobile: ['matchId', 'date', 'liveUpdated', 'status', 'timing']
      },
      hallOfFame: {
        colName: ['sportId', 'competitionId', 'seasonId'],
        isMobile: ['sportId', 'competitionId', 'seasonId']
      },
      drivers: {
        colName: ['driverId', 'driverFirstName', 'shortTeamName', 'victories', 'teamCarBike', 'teamEngine', 'driverLastName', 'driverNumber', 'driverCode', 'teamNat'],
        isMobile: ['driverId', 'driver', 'driverFirstName', 'teamNat', 'team', 'victories', 'teamCarBike', 'teamEngine', 'teamId', 'driverNumber', 'driverCode']
      },
      teams: {
        colName: ['victories', 'teamCarBike', 'teamEngine'],
        isMobile: ['victories', 'teamCarBike', 'teamEngine']
      },
      constructors: {
        colName: ['victories'],
        isMobile: ['victories', 'builder']
      },
      freePractice: {
        colName: ['didx', 'driverFirstName', 'driverLastName', 'stn', 'teamCarbike', 'teamEngine', 'laps', 'pitstops', 'status', 'driverCode', 'cid', 'builder', 'fastInLap', 'fastTime'],
        isMobile: ['didx', 'driverFirstName', 'driverLastName', 'stn', 'teamCarbike', 'teamEngine', 'laps', 'pitstops', 'status', 'driverCode', 'team', 'tid', 'cid', 'builder', 'fastInLap', 'fastTime']
      },
      superpole: {
        colName: ['didx', 'driverFirstName', 'driverLastName', 'stn', 'teamCarbike', 'teamEngine', 'laps', 'pitstops', 'status', 'driverCode', 'cid', 'builder'],
        isMobile: ['didx', 'driverFirstName', 'driver', 'stn', 'teamCarbike', 'teamEngine', 'laps', 'pitstops', 'status', 'time', 'driverCode', 'tid', 'cid', 'builder']
      },
      warmup: {
        colName: ['didx', 'driverFirstName', 'driverLastName', 'stn', 'teamCarbike', 'teamEngine', 'laps', 'pitstops', 'status', 'driverCode', 'cid', 'builder', 'fastInLap', 'fastTime'],
        isMobile: ['didx', 'driverFirstName', 'driver', 'stn', 'teamCarbike', 'teamEngine', 'laps', 'tid', 'pitstops', 'status', 'driverCode', 'team', 'cid', 'builder', 'fastInLap', 'fastTime']
      },
      qualification: {
        colName: ['didx', 'driverFirstName', 'driverLastName', 'stn', 'teamCarbike', 'teamEngine', 'laps', 'pitstops', 'status', 'time', 'driverCode', 'cid', 'builder', 'fastInLap', 'fastTime'],
        isMobile: ['didx', 'driverFirstName', 'driver', 'stn', 'teamCarbike', 'teamEngine', 'laps', 'pitstops', 'status', 'time', 'driverCode', 'tid', 'team', 'cid', 'builder', 'fastInLap', 'fastTime']
      },
      qualification2: {
        colName: ['didx', 'driverFirstName', 'driverLastName', 'stn', 'teamCarbike', 'teamEngine', 'laps', 'pitstops', 'status', 'Q1', 'Q2', 'driverCode', 'cid', 'builder', 'fastInLap', 'fastTime'],
        isMobile: ['didx', 'driverFirstName', 'driver', 'stn', 'teamCarbike', 'teamEngine', 'laps', 'pitstops', 'status', 'Q1', 'Q2', 'driverCode', 'tid', 'team', 'cid', 'builder', 'fastInLap', 'fastTime']
      },
      raceLive: {
        colName: ['didx', 'driverFirstName', 'driverLastName', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'driverCode', 'lapsGap', 'cid', 'builder', 'cid', 'builder'],
        isMobile: ['didx', 'nat', 'driver', 'driverFirstName', 'team', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'driverCode', 'points', 'tid', 'lapsGap', 'cid', 'builder']
      },
      sprintraceLive: {
        colName: ['didx', 'driverFirstName', 'driverLastName', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'driverCode', 'lapsGap', 'cid', 'builder', 'cid', 'builder'],
        isMobile: ['didx', 'nat', 'driver', 'driverFirstName', 'team', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'driverCode', 'points', 'tid', 'lapsGap', 'cid', 'builder']
      },
      sprintqualiLive: {
        colName: ['didx', 'driverFirstName', 'driverLastName', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'driverCode', 'lapsGap', 'cid', 'builder', 'cid', 'builder'],
        isMobile: ['didx', 'nat', 'driver', 'driverFirstName', 'team', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'driverCode', 'points', 'tid', 'lapsGap', 'cid', 'builder']
      },
      race1Live: {
        colName: ['didx', 'driverFirstName', 'driverLastName', 'time', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'driverCode', 'lapsGap', 'cid', 'builder'],
        isMobile: ['didx', 'nat', 'driver', 'driverFirstName', 'team', 'time', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'driverCode', 'points', 'tid', 'lapsGap', 'cid', 'builder']
      },
      race_superpoleLive: {
        colName: ['didx', 'driverFirstName', 'driverLastName', 'time', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'driverCode', 'lapsGap', 'cid', 'builder'],
        isMobile: ['didx', 'nat', 'driver', 'driverFirstName', 'team', 'time', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'driverCode', 'points', 'tid', 'lapsGap', 'cid', 'builder']
      },
      race2Live: {
        colName: ['didx', 'driverFirstName', 'driverLastName', 'time', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'driverCode', 'lapsGap', 'cid', 'builder'],
        isMobile: ['didx', 'nat', 'driver', 'driverFirstName', 'team', 'time', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'driverCode', 'points', 'tid', 'lapsGap', 'cid', 'builder']
      },
      raceEnded: {
        colName: ['didx', 'driverFirstName', 'driverLastName', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'status', 'lapsGap', 'fastInLap', 'fastTime', 'laps', 'driverCode', 'lapsLed', 'cid', 'builder'],
        isMobile: ['didx', 'driver', 'driverFirstName', 'team', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'status', 'lapsGap', 'fastInLap', 'fastTime', 'laps', 'driverCode', 'tid', 'lapsLed', 'cid', 'builder']
      },
      sprintraceEnded: {
        colName: ['didx', 'driverFirstName', 'driverLastName', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'status', 'lapsGap', 'fastInLap', 'fastTime', 'laps', 'driverCode', 'lapsLed', 'cid', 'builder'],
        isMobile: ['didx', 'driver', 'driverFirstName', 'team', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'status', 'lapsGap', 'fastInLap', 'fastTime', 'laps', 'driverCode', 'tid', 'lapsLed', 'cid', 'builder']
      },
      sprintqualiEnded: {
        colName: ['didx', 'driverFirstName', 'driverLastName', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'status', 'lapsGap', 'fastInLap', 'fastTime', 'laps', 'driverCode', 'lapsLed', 'cid', 'builder'],
        isMobile: ['didx', 'driver', 'driverFirstName', 'team', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'status', 'lapsGap', 'fastInLap', 'fastTime', 'laps', 'driverCode', 'tid', 'lapsLed', 'cid', 'builder']
      },
      race1Ended: {
        colName: ['didx', 'driverFirstName', 'driverLastName', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'status', 'lapsGap', 'fastInLap', 'fastTime', 'laps', 'driverCode', 'lapsLed', 'cid', 'builder'],
        isMobile: ['didx', 'driver', 'driverFirstName', 'team', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'status', 'lapsGap', 'fastInLap', 'fastTime', 'laps', 'driverCode', 'tid', 'lapsLed', 'cid', 'builder']
      },
      race_superpoleEnded: {
        colName: ['didx', 'driverFirstName', 'driverLastName', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'status', 'lapsGap', 'fastInLap', 'fastTime', 'laps', 'driverCode', 'lapsLed', 'cid', 'builder'],
        isMobile: ['didx', 'driver', 'driverFirstName', 'team', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'status', 'lapsGap', 'fastInLap', 'fastTime', 'laps', 'driverCode', 'tid', 'lapsLed', 'cid', 'builder']
      },
      race2Ended: {
        colName: ['didx', 'driverFirstName', 'driverLastName', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'status', 'lapsGap', 'fastInLap', 'fastTime', 'laps', 'driverCode', 'lapsLed', 'cid', 'builder'],
        isMobile: ['didx', 'driver', 'driverFirstName', 'team', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'status', 'lapsGap', 'fastInLap', 'fastTime', 'laps', 'driverCode', 'tid', 'lapsLed', 'cid', 'builder']
      },
      players: {
        colName: ['id', 'initials', 'firstName', 'lastName'],
        isMobile: ['id', 'initials', 'firstName', 'displayName']
      },
      basketStandings: {
        colName: ['gamesBack', 'teamOfficialName', 'teamCode', 'team', 'conferenceWon', 'conferenceLost', 'divisionWon', 'divisionLost'],
        isMobile: ['gamesBack', 'won', 'lost', 'winPercentage', 'teamOfficialName', 'teamCode', 'team', 'conferenceWon', 'conferenceLost', 'divisionWon', 'divisionLost'],
        colName_6: ['gamesBack', 'teamOfficialName', 'teamCode', 'team', 'winPercentage']
      }
    },
    tableTabbar: {
      teamPagePreMatch: [{
        label: 'Notizie',
        id: 0,
        url: 'notizie'
      }, {
        label: 'Probabili Formazioni',
        id: 1,
        url: 'probabili-formazioni',
        hide: true
      }, {
        label: 'Formazioni',
        id: 2,
        url: 'formazioni',
        hide: false
      }, {
        label: 'Quote',
        id: 3,
        url: 'quote',
        hide: false
      }, {
        label: 'Statistiche',
        id: 4,
        url: 'statistiche'
      }, {
        label: 'Classifica',
        id: 5,
        url: 'classifica'
      }, {
        label: 'Commenta',
        id: 6,
        url: 'commenti'
      }],
      teamPage: [{
        label: 'Notizie',
        id: 0,
        url: 'notizie'
      }, {
        label: 'Cronaca',
        id: 1,
        url: 'cronaca'
      }, {
        label: 'Sintesi',
        id: 2,
        url: 'sintesi'
      }, {
        label: 'Tabellino',
        id: 3,
        url: 'tabellino'
      }, {
        label: 'Quote',
        id: 4,
        url: 'quote',
        hide: false
      }, {
        label: 'Statistiche',
        id: 5,
        url: 'statistiche'
      }, {
        label: 'Classifica',
        id: 6,
        url: 'classifica'
      }, {
        label: 'Commenta',
        id: 7,
        url: 'commenti'
      }],
      teamPageFull: [{
        label: 'Notizie',
        id: 0,
        url: 'notizie'
      }, {
        label: 'Cronaca',
        id: 1,
        url: 'cronaca'
      }, {
        label: 'Sintesi',
        id: 2,
        url: 'sintesi'
      }, {
        label: 'Vota',
        id: 3,
        url: 'vota'
      }, {
        label: 'Tabellino',
        id: 4,
        url: 'tabellino'
      }, {
        label: 'Quote',
        id: 5,
        url: 'quote',
        hide: false
      }, {
        label: 'Statistiche',
        id: 6,
        url: 'statistiche'
      }, {
        label: 'Classifica',
        id: 7,
        url: 'classifica'
      }, {
        label: 'Commenta',
        id: 8,
        url: 'commenti'
      }],
      competitionTeams: [{
        label: 'Generale',
        id: 'generalRanking'
      }, {
        label: 'Casa',
        id: 'homeRanking'
      }, {
        label: 'Trasferta',
        id: 'awayRanking'
      }],
      cupstandings: [{
        label: 'Qualificazioni',
        name: 'preliminaries',
        id: 0,
        url: '/qualification'
      }, {
        label: 'Stagione regolare',
        name: 'regularSeason',
        id: 0,
        url: '/regularSeason'
      }, {
        label: 'Fase a gironi',
        name: 'groups',
        id: 1,
        url: '/gironi'
      }, {
        label: 'Girone Unico',
        name: 'championship',
        id: 3,
        url: '/championship'
      }, {
        label: 'Play off',
        name: 'playoffs',
        id: 2,
        url: '/playoff'
      }, {
        label: 'Play out',
        name: 'playout',
        id: 3,
        url: '/playout'
      }],
      4: [{
        label: 'Preliminari',
        name: 'preliminaries',
        id: 0,
        url: '/qualification'
      }, {
        label: 'Gironi',
        name: 'groups',
        id: 1,
        url: '/gironi'
      }, {
        label: 'Fase finale',
        name: 'playoffs',
        id: 2,
        url: '/playoff'
      }],
      standingTeams: [{
        label: 'Generale',
        id: 'generalRanking'
      }, {
        label: 'Casa',
        id: 'homeRanking'
      }, {
        label: 'Trasferta',
        id: 'awayRanking'
      }],
      35: [{
        label: 'Generale',
        id: 'generalRanking'
      }],
      34: [{
        label: 'Generale',
        id: 'generalRanking'
      }],
      realteamPage: [{
        label: 'Notizie',
        id: 'news',
        url: 'news'
      }, {
        label: 'Probabili',
        id: 'lineup',
        url: 'lineup',
        hide: true
      }, {
        label: 'Statistiche',
        id: 'stats',
        url: 'stats'
      }, {
        label: 'Rosa',
        id: 'squad',
        url: 'squad'
      }, {
        label: 'Società',
        id: 'club',
        url: 'club'
      }],
      raceNotStarted: [{
        label: 'Notizie',
        id: 0,
        url: 'notizie'
      }, {
        label: 'Cronaca',
        id: 1,
        url: 'sintesi'
      }, {
        label: 'Quote',
        id: 2,
        url: 'quote',
        hide: false
      }, {
        label: 'Risultati',
        id: 3,
        url: 'risultati'
      }, {
        label: 'Classifica',
        id: 4,
        url: 'classifica'
      }, {
        label: 'Commenta',
        id: 5,
        url: 'commenti'
      }],
      raceOnTrack: [{
        label: 'Notizie',
        id: 0,
        url: 'notizie'
      }, {
        label: 'Cronaca',
        id: 1,
        url: 'sintesi'
      }, {
        label: 'Quote',
        id: 2,
        url: 'quote',
        hide: false
      }, {
        label: 'Risultati',
        id: 3,
        url: 'risultati'
      }, {
        label: 'Classifica',
        id: 4,
        url: 'classifica'
      }, {
        label: 'Commenta',
        id: 5,
        url: 'commenti'
      }],
      raceFinished: [{
        label: 'Notizie',
        id: 0,
        url: 'notizie'
      }, {
        label: 'Cronaca',
        id: 1,
        url: 'sintesi'
      }, {
        label: 'Quote',
        id: 2,
        url: 'quote',
        hide: false
      }, {
        label: 'Risultati',
        id: 3,
        url: 'risultati'
      }, {
        label: 'Classifica',
        id: 4,
        url: 'classifica'
      }, {
        label: 'Commenta',
        id: 5,
        url: 'commenti'
      }],
      racePhases: [{
        label: 'Prove libere',
        id: 0,
        url: '/freePractice'
      }, {
        label: 'Qualifiche',
        id: 1,
        url: '/qualification'
      }, {
        label: 'Gara',
        id: 2,
        url: '/race'
      }],
      raceStandings: [{
        label: 'Piloti',
        id: 0,
        url: '/drivers'
      }, {
        label: 'Costruttori',
        id: 1,
        url: '/constructors'
      }],
      tennisPreMatch: [{
        label: 'Quote',
        id: 0,
        url: 'quote',
        hide: false
      }, {
        label: 'Precedenti',
        id: 1,
        url: 'statistiche'
      }, {
        label: 'Commenta',
        id: 2,
        url: 'commenti'
      }],
      tennisLive: [{
        label: 'Sintesi',
        id: 0,
        url: 'sintesi'
      }, {
        label: 'Quote',
        id: 1,
        url: 'quote',
        hide: true
      }, {
        label: 'Precedenti',
        id: 2,
        url: 'statistiche'
      }, {
        label: 'Commenta',
        id: 3,
        url: 'commenti'
      }],
      basketLiveMatch: [{
        label: 'Notizie',
        id: 0,
        url: 'notizie'
      }, {
        label: 'Cronaca',
        id: 1,
        url: 'sintesi'
      }, {
        label: 'Classifica',
        id: 2,
        url: 'classifica'
      }, {
        label: 'Commenta',
        id: 3,
        url: 'commenti'
      }],
      nbaLiveMatch: [{
        label: 'Notizie',
        id: 0,
        url: 'notizie'
      }, {
        label: 'Formazioni',
        id: 1,
        url: 'formazioni'
      }, {
        label: 'Tabellino',
        id: 2,
        url: 'tabellino'
      }, {
        label: 'Statistiche',
        id: 3,
        url: 'statistiche'
      }, {
        label: 'Classifica',
        id: 4,
        url: 'classifica'
      }, {
        label: 'Commenta',
        id: 5,
        url: 'commenti'
      }],
      basketPreMatch: [{
        label: 'Notizie',
        id: 0,
        url: 'notizie'
      }, {
        label: 'Classifica',
        id: 1,
        url: 'classifica'
      }, {
        label: 'Commenta',
        id: 2,
        url: 'commenti'
      }],
      nbaPreMatch: [{
        label: 'Notizie',
        id: 0,
        url: 'notizie'
      }, {
        label: 'Formazioni',
        id: 1,
        url: 'formazioni'
      }, {
        label: 'Classifica',
        id: 2,
        url: 'classifica'
      }, {
        label: 'Commenta',
        id: 3,
        url: 'commenti'
      }],
      basketPostMatch: [{
        label: 'Notizie',
        id: 0,
        url: 'notizie'
      }, {
        label: 'Cronaca',
        id: 1,
        url: 'sintesi'
      }, {
        label: 'Tabellino',
        id: 2,
        url: 'tabellino'
      }, {
        label: 'Statistiche',
        id: 3,
        url: 'statistiche'
      }, {
        label: 'Classifica',
        id: 4,
        url: 'classifica'
      }, {
        label: 'Commenta',
        id: 5,
        url: 'commenti'
      }],
      nbaPostMatch: [{
        label: 'Notizie',
        id: 0,
        url: 'notizie'
      }, {
        label: 'Formazioni',
        id: 1,
        url: 'formazioni'
      }, {
        label: 'Tabellino',
        id: 2,
        url: 'tabellino'
      }, {
        label: 'Statistiche',
        id: 3,
        url: 'statistiche'
      }, {
        label: 'Classifica',
        id: 4,
        url: 'classifica'
      }, {
        label: 'Commenta',
        id: 5,
        url: 'commenti'
      }]
    },
    tableTabbarCorriere: {
      teamPagePreMatch: [{
        label: 'Notizie',
        id: 0,
        url: 'notizie'
      }, {
        label: 'Quote',
        id: 1,
        url: 'quote',
        hide: true
      }, {
        label: 'Formazioni',
        id: 2,
        url: 'formazioni',
        hide: true
      }, {
        label: 'Statistiche',
        id: 3,
        url: 'statistiche'
      }, {
        label: 'Classifica',
        id: 4,
        url: 'classifica'
      }, {
        label: 'Commenta',
        id: 5,
        url: 'commenti'
      }],
      teamPage: [{
        label: 'Notizie',
        id: 0,
        url: 'notizie'
      }, {
        label: 'Cronaca',
        id: 1,
        url: 'cronaca'
      }, {
        label: 'Sintesi',
        id: 2,
        url: 'sintesi'
      }, {
        label: 'Tabellino',
        id: 3,
        url: 'tabellino'
      }, {
        label: 'Quote',
        id: 4,
        url: 'quote',
        hide: true
      }, {
        label: 'Statistiche',
        id: 5,
        url: 'statistiche'
      }, {
        label: 'Classifica',
        id: 6,
        url: 'classifica'
      }, {
        label: 'Commenta',
        id: 7,
        url: 'commenti'
      }],
      teamPageFull: [{
        label: 'Notizie',
        id: 0,
        url: 'notizie'
      }, {
        label: 'Cronaca',
        id: 1,
        url: 'cronaca'
      }, {
        label: 'Sintesi',
        id: 2,
        url: 'sintesi'
      }, {
        label: 'Tabellino',
        id: 3,
        url: 'tabellino'
      }, {
        label: 'Statistiche',
        id: 4,
        url: 'statistiche'
      }, {
        label: 'Classifica',
        id: 5,
        url: 'classifica'
      }, {
        label: 'Commenta',
        id: 6,
        url: 'commenti'
      }],
      competitionTeams: [{
        label: 'Generale',
        id: 'generalRanking'
      }, {
        label: 'Casa',
        id: 'homeRanking'
      }, {
        label: 'Trasferta',
        id: 'awayRanking'
      }],
      cupstandings: [{
        label: 'Qualificazioni',
        id: 0,
        url: '/qualification'
      }, {
        label: 'Fase a gironi',
        id: 1,
        url: '/gironi'
      }, {
        label: 'Fase a eliminazione diretta',
        id: 2,
        url: '/playoff'
      }],
      4: [{
        label: 'Gironi',
        id: 1,
        url: '/gironi'
      }, {
        label: 'Fase finale',
        id: 2,
        url: '/playoff'
      }],
      realteamPage: [{
        label: 'Notizie',
        id: 'news',
        url: 'news'
      }, {
        label: 'Probabili',
        id: 'lineup',
        url: 'lineup',
        hide: true
      }, {
        label: 'Statistiche',
        id: 'stats',
        url: 'stats'
      }, {
        label: 'Rosa',
        id: 'squad',
        url: 'squad'
      }, {
        label: 'Società',
        id: 'club',
        url: 'club'
      }],
      raceNotStarted: [{
        label: 'Notizie',
        id: 0,
        url: 'notizie'
      }, {
        label: 'Cronaca',
        id: 1,
        url: 'sintesi'
      }, {
        label: 'Quote',
        id: 2,
        url: 'quote',
        hide: true
      }, {
        label: 'Qualifiche',
        id: 3,
        url: 'qualificazioni'
      }, {
        label: 'Classifica',
        id: 4,
        url: 'classifica'
      }, {
        label: 'Commenta',
        id: 5,
        url: 'commenti'
      }],
      raceOnTrack: [{
        label: 'Notizie',
        id: 0,
        url: 'notizie'
      }, {
        label: 'Cronaca',
        id: 1,
        url: 'sintesi'
      }, {
        label: 'Quote',
        id: 2,
        url: 'quote',
        hide: true
      }, {
        label: 'Statistiche',
        id: 3,
        url: 'statistiche'
      }, {
        label: 'Classifica',
        id: 4,
        url: 'classifica'
      }, {
        label: 'Commenta',
        id: 5,
        url: 'commenti'
      }],
      raceFinished: [{
        label: 'Notizie',
        id: 0,
        url: 'notizie'
      }, {
        label: 'Cronaca',
        id: 1,
        url: 'sintesi'
      }, {
        label: 'Statistiche',
        id: 2,
        url: 'statistiche'
      }, {
        label: 'Classifica',
        id: 3,
        url: 'classifica'
      }, {
        label: 'Commenta',
        id: 4,
        url: 'commenti'
      }],
      racePhases: [{
        label: 'Prove libere',
        id: 0,
        url: '/freePractice'
      }, {
        label: 'Qualifiche',
        id: 1,
        url: '/qualification'
      }, {
        label: 'Gara',
        id: 2,
        url: '/race'
      }],
      raceStandings: [{
        label: 'Piloti',
        id: 0,
        url: '/drivers'
      }, {
        label: 'Costruttori',
        id: 1,
        url: '/constructors'
      }]
    }
  },
  widgets: {
    colsPosition: {
      competitionTeams: {
        teamName: 3,
        drawn: 8,
        englishMean: 12,
        form: 13,
        goalsConceded: 11,
        goalsMade: 10,
        lost: 9,
        played: 6,
        points: 5,
        position: 1,
        startingPosition: 4,
        won: 7,
        teamId: 2
      },
      competitionMarkers: {
        goals: 7,
        penalties: 8,
        playerId: 1,
        playerName: 3,
        playerRole: 6,
        playerCountry: 2,
        teamId: 4,
        teamName: 5
      },
      rugbyStandings: {
        teamName: 3,
        drawn: 7,
        lost: 8,
        pointsDiff: 9,
        played: 5,
        points: 4,
        rank: 1,
        won: 6,
        teamId: 2
      }
    },
    joinedCols: {
      competitionTeams: {
        leftCol: 'goalsMade',
        rightCol: 'goalsConceded'
      },
      competitionMarkers: {
        leftCol: '',
        rightCol: ''
      },
      rugbyStandings: [{ leftCol: 'triesBonus', rightCol: 'losingBonus' }, { leftCol: 'triesFor', rightCol: 'triesAgainst' }]
    },
    skipCols: {
      competitionTeams: {
        colName: ['qualification', 'englishMean', 'form', 'goalsMade', 'goalsConceded'],
        isMobile: ['qualification', 'englishMean', 'form', 'goalsMade', 'goalsConceded']
      },
      competitionMarkers: {
        colName: ['teamId', 'playerCountry', 'playerRole', 'playerFirstName', 'playerSecondName', 'playerBirthDate', 'playerKnowName'],
        isMobile: ['teamId', 'playerCountry', 'playerRole', 'playerFirstName', 'playerSecondName', 'playerBirthDate', 'playerKnowName']
      },
      rugbyStandings: {
        colName: ['against', 'bonus', 'for', 'losingBonus', 'triesBonus', 'triesAgainst', 'triesFor'],
        isMobile: ['against', 'bonus', 'for', 'losingBonus', 'triesBonus', 'triesAgainst', 'triesFor']
      }
    },
    positionMarker: {
      Europa_Cup: {
        League_Position: 'lightRed',
        League_Position_Q1: 'lightPink',
        League_Position_Q2: 'lightPink',
        League_Position_Q3: 'lightPink'
      },
      Champions_League: {
        League_Winners: 'mediumBlue',
        League_Winners_Q1: 'lightBlue',
        League_Winners_Q2: 'lightBlue',
        League_Winners_Q3: 'lightBlue',
        League_Position: 'mediumBlue',
        League_Position_Q1: 'lightBlue',
        League_Position_Q2: 'lightBlue',
        League_Position_Q3: 'lightBlue'
      },
      Relegation: {
        League_Position: 'lightYellow',
        Play_Off: 'lightYellow',
        Playoff_Relegation: 'lightYellow'
      },
      Promotion: {
        League_Winners: 'mediumBlue',
        League_Position: 'mediumBlue',
        Play_Off: 'lightRed'
      },
      Champions_League_Qualifying: {
        League_Winners: 'mediumBlue',
        League_Winners_Q1: 'lightBlue',
        League_Winners_Q2: 'lightBlue',
        League_Winners_Q3: 'lightBlue',
        League_Position: 'mediumBlue',
        League_Position_Q1: 'lightBlue',
        League_Position_Q2: 'lightBlue',
        League_Position_Q3: 'lightBlue'
      }
    }
  },
  imageUrls: {
    football: {
      teams: {
        min: 'https://images2.gazzettaobjects.it/assets-mc/calcio/squadre/min/',
        med: 'https://images2.gazzettaobjects.it/assets-mc/calcio/squadre/med/',
        high: 'https://images2.gazzettaobjects.it/assets-mc/calcio/squadre/high/'
      },
      players: 'https://images2.gazzettaobjects.it/assets-mc/calcio/giocatori/'
    },
    volley: {
      teams: {
        min: 'https://images2.gazzettaobjects.it/assets-mc/volley/squadre/min/'
      }
    },
    teams: 'https://images2.gazzettaobjects.it/assets-mc/motori/teams/',
    circuits: 'https://images2.gazzettaobjects.it/assets-mc/motori/circuiti/',
    countriesFlag: 'https://images2.gazzettaobjects.it/assets-mc/countries/med/',
    tennisPlayer: 'https://images2.gazzettaobjects.it/assets-mc/tennis/giocatori/',
    tennisPlayers: {
      min: 'https://images2.gazzettaobjects.it/assets-mc/tennis/giocatori/min/',
      high: 'https://images2.gazzettaobjects.it/assets-mc/tennis/giocatori/high/'
    },
    basket: {
      teams: {
        min: 'https://images2.gazzettaobjects.it/assets-mc/basket/squadre/min/',
        med: 'https://images2.gazzettaobjects.it/assets-mc/basket/squadre/med/',
        high: 'https://images2.gazzettaobjects.it/assets-mc/basket/squadre/high/'
      },
      players: 'https://images2.gazzettaobjects.it/assets-mc/basket/giocatori/'
    },
    rugby: {
      teams: {
        min: 'https://images2.gazzettaobjects.it/assets-mc/rugby/squadre/min/',
        med: 'https://images2.gazzettaobjects.it/assets-mc/rugby/squadre/med/',
        high: 'https://images2.gazzettaobjects.it/assets-mc/rugby/squadre/high/'
      }
    }
  },
  cyclingCustomUrl: {
    /*7101: 'https://www.giroditalia.it/it/',
    90054: 'http://www.tirrenoadriatico.it/',
    90055: 'http://www.milanosanremo.it/',
    90075: 'http://www.ilombardia.it/', */
  }
};

var prettyCyclingCompetitionId = function prettyCyclingCompetitionId() {
  var competizione = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  if (competizione) {
    var valueKeys = Object.values(configJson.dictionary.it.cyclingCompetitionLink);
    var keys = Object.keys(configJson.dictionary.it.cyclingCompetitionLink);
    if (valueKeys.indexOf(competizione) > -1) {
      var index = valueKeys.indexOf(competizione);
      return keys[index];
    }
  }
  return false;
};

var prettyCyclingCompetitionLabel = function prettyCyclingCompetitionLabel() {
  var competitionId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  if (competitionId && configJson.dictionary.it.cyclingCompetitionLabel[competitionId]) {
    return configJson.dictionary.it.cyclingCompetitionLabel[competitionId];
  }
  return '';
};

var cleanTeamOrNameUrl = function cleanTeamOrNameUrl() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '#';
  var joinChar = arguments[1];
  var sportId = arguments[2];

  name = name.toLowerCase().replace(/\s\(-[0-9]{1,3}\)/g, '').replace(/`/g, '').replace(/\//g, '').replace(/\./g, '').replace(/¡/g, 'i').replace(/\(/g, '').replace(/\)/g, '').replace(/\|/g, '').replace(/¢/g, '').replace(/£/g, '').replace(/¤/g, '').replace(/¥/g, '').replace(/¦/g, '').replace(/§/g, '').replace(/¨/g, '').replace(/©/g, '').replace(/ª/g, '').replace(/«/g, '').replace(/¬/g, '').replace(/­/g, '').replace(/¯/g, '').replace(/°/g, '').replace(/²/g, '').replace(/³/g, '').replace(/´/g, '').replace(/µ/g, '').replace(/¶/g, '').replace(/·/g, '').replace(/¸/g, '').replace(/¹/g, '').replace(/º/g, '').replace(/»/g, '').replace(/¼/g, '').replace(/½/g, '').replace(/¾/g, '').replace(/¿/g, '').replace(/À/g, 'a').replace(/Á/g, 'a').replace(/Â/g, 'a').replace(/Ã/g, 'a').replace(/Ä/g, 'a').replace(/Å/g, 'a').replace(/Æ/g, 'a').replace(/Ç/g, 'c').replace(/È/g, 'e').replace(/É/g, 'e').replace(/Ê/g, 'e').replace(/Ë/g, 'e').replace(/Ì/g, 'i').replace(/Í/g, 'i').replace(/Î/g, 'i').replace(/Ï/g, 'i').replace(/Ð/g, 'd').replace(/Ñ/g, 'n').replace(/Ò/g, 'o').replace(/Ó/g, 'o').replace(/Ô/g, 'o').replace(/Õ/g, 'o').replace(/Ö/g, 'o').replace(/×/g, 'x').replace(/Ø/g, '0').replace(/Ù/g, 'u').replace(/Ú/g, 'u').replace(/Û/g, 'u').replace(/Ü/g, 'u').replace(/Ý/g, 'y').replace(/Þ/g, 'p').replace(/ß/g, 'b').replace(/à/g, 'a').replace(/á/g, 'a').replace(/â/g, 'a').replace(/ã/g, 'a').replace(/ä/g, 'a').replace(/å/g, 'a').replace(/æ/g, 'a').replace(/ç/g, 'c').replace(/è/g, 'e').replace(/é/g, 'e').replace(/ê/g, 'e').replace(/ë/g, 'e').replace(/ì/g, 'i').replace(/í/g, 'i').replace(/î/g, 'i').replace(/ï/g, 'i').replace(/ð/g, 'o').replace(/ñ/g, 'n').replace(/ò/g, 'o').replace(/ó/g, 'o').replace(/ô/g, 'o').replace(/õ/g, 'o').replace(/ö/g, 'o').replace(/÷/g, '').replace(/ø/g, 'o').replace(/ù/g, 'u').replace(/ú/g, 'u').replace(/û/g, 'u').replace(/ü/g, 'u').replace(/ý/g, 'y').replace(/þ/g, 'b').replace(/ÿ/g, 'y').replace(/š/g, 's').replace(/ž/g, 'z').replace(/ė/g, 'z').replace(/ū/g, 'u').replace(/'/g, '').split(' ').filter(function (c) {
    return c !== '-' && c !== '';
  }).join(joinChar);

  if (sportId === '12') {
    name = name.replace(/'/g, '-');
  }

  return name;
};

var prettySitePath = function prettySitePath(site) {
  //let pahtprefix = configJson.urlToUse === 'production' ? 'www' : 'dev';
  //const pahtprefix = configJson.urlToUse === 'production' ? 'www' : 'www';
  var pahtprefix = configJson.urlToUse === 'development' || configJson.urlToUse === 'stag' ? 'dev' : 'www';
  var path = '';
  switch (site) {
    case 'gazzetta':
      path = 'https://' + pahtprefix + '.gazzetta.it';
      break;
    case 'corriere':
      path = 'https://' + pahtprefix + '.corriere.it/sport';
      break;
    case 'fcinter':
    case 'fcinter1908':
      path = 'https://' + pahtprefix + '.fcinter1908.it';
      break;
    case 'forzaroma':
      path = 'https://' + pahtprefix + '.forzaroma.info';
      break;
    case 'calcionapoli1926':
      path = 'https://' + pahtprefix + '.calcionapoli1926.it';
      break;
    default:
      break;
  }
  return path;
};

var prettyMatchUrl = function prettyMatchUrl(teamHome, teamAway, matchId, sportId, competitionId, site, tennisTournament, seasonLink) {
  var fallbackUrl = false;

  var competitionLink = '';
  var path = prettySitePath(site);
  var prefix = '';
  var postfix = '';
  var url = '';

  if (teamHome) {
    teamHome = cleanTeamOrNameUrl(teamHome, '');
  }

  if (teamAway) {
    teamAway = cleanTeamOrNameUrl(teamAway, '');
  }

  sportId = String(sportId);
  switch (sportId) {
    case '1':
      if (site === 'fcinter' || site === 'fcinter1908' || site === 'forzaroma' || site === 'calcionapoli1926') {
        prefix = '/competizioni-calcio';
      } else {
        prefix = '/calcio';
      }
      postfix = 'partita';
      competitionLink = configJson.dictionary.it.competitionLink[Number(competitionId)];
      if (site === 'corriere' && '' + competitionId === '1277') competitionLink = 'mondiale-per-club-fifa';
      // seasonLink es. "2017-18/"
      if (seasonLink) {
        url = '' + path + prefix + '/' + competitionLink + '/' + postfix + '/' + seasonLink + teamHome + '-' + teamAway + '/' + matchId + '/';
      } else {
        url = '' + path + prefix + '/' + competitionLink + '/' + postfix + '/' + teamHome + '-' + teamAway + '/' + matchId + '/';
      }
      break;
    case '6C':
    case '6M':
      prefix = '/motori';
      postfix = 'gran-premio';
      competitionLink = configJson.dictionary.it.raceCompetitionLink[Number(competitionId)];
      if (!teamAway && !teamHome) {
        fallbackUrl = true;
      }
      url = '' + path + prefix + '/' + competitionLink + '/' + postfix + '/' + teamHome + '/' + matchId + '/';
      break;
    case '8':
      prefix = '/tennis';
      postfix = 'partita';
      if (tennisTournament) {
        tennisTournament = cleanTeamOrNameUrl(tennisTournament, '-');
      } else {
        fallbackUrl = true;
      }
      url = '' + path + prefix + '/' + tennisTournament + '/' + postfix + '/' + teamHome + '-' + teamAway + '/' + matchId + '/';
      break;
    case '3':
      prefix = '/basket';
      postfix = 'partita';
      competitionLink = configJson.dictionary.it.basketCompetitionLink[Number(competitionId)];
      url = '' + path + prefix + '/' + competitionLink + '/' + postfix + '/' + teamHome + '-' + teamAway + '/' + matchId + '/';
      break;
    case '5':
      prefix = '/volley';
      postfix = 'partita';
      competitionLink = configJson.dictionary.it.volleyCompetitionLink[Number(competitionId)];
      url = '' + path + prefix + '/' + competitionLink + '/' + postfix + '/' + teamHome + '-' + teamAway + '/' + matchId + '/';
      break;
    case '2':
      fallbackUrl = true;
      break;
    default:
      fallbackUrl = true;
      break;
  }
  return !fallbackUrl ? url : '#';
};

var prettyPlayerUrl = function prettyPlayerUrl(playerName, playerId, sportId, site) {
  playerName = cleanTeamOrNameUrl(playerName, '-');

  var competitionLink = '';
  var path = '';
  //let pahtprefix = configJson.urlToUse === 'production' ? 'www' : 'dev';
  var pahtprefix = configJson.urlToUse === 'production' ? 'www' : 'www';
  var prefix = '';
  var postfix = '';
  var url = '';

  sportId = String(sportId);

  switch (site) {
    case 'gazzetta':
      path = 'https://' + pahtprefix + '.gazzetta.it';
      break;
    case 'corriere':
      path = 'https://' + pahtprefix + '.corriere.it/sport';
      break;
    case 'fcinter':
    case 'fcinter1908':
      path = 'https://' + pahtprefix + '.fcinter1908.it';
      break;
    case 'forzaroma':
      path = 'https://' + pahtprefix + '.forzaroma.info';
      break;
    case 'calcionapoli1926':
      path = 'https://' + pahtprefix + '.calcionapoli1926.it';
      break;
    default:
      break;
  }

  switch (sportId) {
    case '1':
      if (site === 'fcinter' || site === 'fcinter1908' || site === 'forzaroma' || site === 'calcionapoli1926') {
        prefix = '/competizioni-calcio';
      } else {
        prefix = '/calcio';
      }
      postfix = 'giocatori';
      break;
    case '6C':
    case '6M':
      prefix = '/motori';
      postfix = 'piloti';
      break;
    case '8':
      prefix = '/tennis';
      postfix = 'giocatori';
      break;
    case '18':
      prefix = '/ciclismo';
      postfix = 'ciclisti';
      break;
    case '12':
      prefix = '/sport-invernali';
      postfix = 'atleti';
      break;
    default:
      break;
  }

  switch (sportId) {
    case '1':
    case '8':
    case '12':
      url = '' + path + prefix + '/' + postfix + '/' + playerName + '/' + playerId + '/';
      break;
    case '6M':
    case '6C':
      url = '' + path + prefix + '/' + postfix + '/' + playerName + '-' + sportId + '/' + playerId + '/';
      break;
    default:
      break;
  }

  return url;
};

var prettyTopScorersUrl = function prettyTopScorersUrl(sportId, competitionId, site) {
  var competitionLink = '';
  var path = '';
  //let pahtprefix = configJson.urlToUse === 'production' ? 'www' : 'dev';
  var pahtprefix = configJson.urlToUse === 'production' ? 'www' : 'www';
  var prefix = '';
  var postfix = '';
  var url = '';

  sportId = String(sportId);
  competitionLink = configJson.dictionary.it.competitionLink[Number(competitionId)];
  if (site === 'corriere' && '' + competitionId === '1277') competitionLink = 'mondiale-per-club-fifa';

  switch (site) {
    case 'gazzetta':
      path = 'https://' + pahtprefix + '.gazzetta.it';
      break;
    case 'corriere':
      path = 'https://' + pahtprefix + '.corriere.it/sport';
      break;
    case 'fcinter':
    case 'fcinter1908':
      path = 'https://' + pahtprefix + '.fcinter1908.it';
      break;
    case 'forzaroma':
      path = 'https://' + pahtprefix + '.forzaroma.info';
      break;
    case 'calcionapoli1926':
      path = 'https://' + pahtprefix + '.calcionapoli1926.it';
      break;
    default:
      break;
  }

  switch (sportId) {
    case '1':
      if (site === 'fcinter' || site === 'fcinter1908' || site === 'forzaroma' || site === 'calcionapoli1926') {
        prefix = '/competizioni-calcio';
      } else {
        prefix = '/calcio';
      }
      postfix = 'marcatori';
      break;
    case '6C':
    case '6M':
      prefix = '/motori';
      postfix = 'piloti';
      break;
    case '8':
      prefix = '/tennis';
      postfix = 'giocatori';
      break;
    default:
      break;
  }

  url = '' + path + prefix + '/' + competitionLink + '/' + postfix + '/';

  return url;
};

var prettyStandingsUrl = function prettyStandingsUrl(sportId, competitionId, site, isStage) {
  var path = prettySitePath(site);

  var competitionLink = configJson.dictionary.it.competitionLink[Number(competitionId)];
  if (site === 'corriere' && '' + competitionId === '1277') competitionLink = 'mondiale-per-club-fifa';
  var prefix = '';
  var postfix = '';

  sportId = String(sportId);
  switch (sportId) {
    case '1':
      if (site === 'fcinter' || site === 'fcinter1908' || site === 'forzaroma' || site === 'calcionapoli1926') {
        prefix = '/competizioni-calcio';
      } else {
        prefix = '/calcio';
      }
      postfix = 'classifica';
      break;
    case '6C':
    case '6M':
      prefix = '/motori';
      postfix = 'classifiche';
      competitionLink = configJson.dictionary.it.raceCompetitionLink[competitionId];
      break;
    case '8':
      prefix = '/tennis';
      postfix = 'giocatori';
      break;
    case '18':
      prefix = '/ciclismo';
      postfix = 'classifiche';
      if (isStage) {
        postfix = 'classifica';
      }
      competitionLink = configJson.dictionary.it.cyclingCompetitionLink[Number(competitionId)];
      break;
    case '3':
      prefix = '/basket';
      postfix = 'classifica';
      competitionLink = configJson.dictionary.it.basketCompetitionLink[Number(competitionId)];
      break;
    case '5':
      prefix = '/volley';
      postfix = 'classifiche';
      competitionLink = configJson.dictionary.it.volleyCompetitionLink[Number(competitionId)];
      break;
    case '2':
      prefix = '/rugby';
      postfix = 'classifica';
      competitionLink = configJson.dictionary.it.rugbyCompetitionLink[Number(competitionId)];
      break;
    case '12':
      prefix = '/sport-invernali/sci-alpino';
      postfix = 'calendario-risultati';
      competitionLink = configJson.dictionary.it.skiCompetitionLink[Number(competitionId)];
      break;
    default:
      break;
  }

  return '' + path + prefix + '/' + competitionLink + '/' + postfix + '/';
};

var prettyCalendarUrl = function prettyCalendarUrl(sportId, competitionId, site) {
  if (sportId === '18') {
    var cyclingIds = Object.keys(configJson.cyclingCustomUrl);
    if (cyclingIds.indexOf(competitionId) !== -1) {
      return configJson.cyclingCustomUrl[competitionId];
    }
  }

  var path = prettySitePath(site);
  var competitionLink = configJson.dictionary.it.competitionLink[Number(competitionId)];
  if (site === 'corriere' && '' + competitionId === '1277') competitionLink = 'mondiale-per-club-fifa';
  var prefix = '';
  var postfix = '';

  sportId = String(sportId);
  switch (sportId) {
    case '1':
      if (site === 'fcinter' || site === 'fcinter1908' || site === 'forzaroma' || site === 'calcionapoli1926') {
        prefix = '/competizioni-calcio';
      } else {
        prefix = '/calcio';
      }
      postfix = 'calendario-risultati';
      break;
    case '6C':
    case '6M':
      prefix = '/motori';
      postfix = 'piloti';
      break;
    case '8':
      prefix = '/tennis';
      postfix = 'giocatori';
      break;
    case '2':
      prefix = '/rugby';
      postfix = 'calendario-risultati';
      competitionLink = configJson.dictionary.it.rugbyCompetitionLink[Number(competitionId)];
      break;
    case '3':
      prefix = '/basket';
      postfix = 'calendario-risultati';
      competitionLink = configJson.dictionary.it.basketCompetitionLink[Number(competitionId)];
      break;
    case '5':
      prefix = '/volley';
      postfix = 'calendario-risultati';
      competitionLink = configJson.dictionary.it.volleyCompetitionLink[Number(competitionId)];
      break;
    case '12':
      prefix = '/sport-invernali/sci-alpino';
      postfix = 'calendario-risultati';
      competitionLink = configJson.dictionary.it.skiCompetitionLink[Number(competitionId)];
      break;
    case '18':
      prefix = '/ciclismo';
      postfix = 'calendario-risultati';
      competitionLink = configJson.dictionary.it.cyclingCompetitionLink[Number(competitionId)];
      break;
    default:
      break;
  }

  return '' + path + prefix + '/' + competitionLink + '/' + postfix + '/';
};

var prettyTeamUrl = function prettyTeamUrl(sportId, competitionId, site, team) {
  var path = prettySitePath(site);
  var prefix = '';
  var postfix = '';
  var url = '';
  sportId = String(sportId);
  switch (sportId) {
    case '1':
      if (site === 'fcinter' || site === 'fcinter1908' || site === 'forzaroma' || site === 'calcionapoli1926') {
        prefix = '/competizioni-calcio';
        url = '' + path + prefix + '/serie-a/';
      } else {
        prefix = '/calcio';
        postfix = 'squadre';
        var teamClean = cleanTeamOrNameUrl(team, '-');
        url = '' + path + prefix + '/' + postfix + '/' + teamClean.toLowerCase() + '/';
      }
      break;
    case '6C':
    case '6M':
      prefix = '/motori';
      postfix = 'scuderie';
      var raceCompetitionLink = configJson.dictionary.it.raceCompetitionLink[Number(competitionId)];
      var teamDashed = cleanTeamOrNameUrl(team, '-');
      url = '' + path + prefix + '/' + postfix + '/' + raceCompetitionLink + '/' + teamDashed + '/';
      break;
    case '8':
      prefix = '/tennis';
      postfix = '';
      var tennisTeam = cleanTeamOrNameUrl(team, '');
      url = '' + path + prefix + '/' + postfix + '/' + tennisTeam.toLowerCase() + '/';
      break;
    default:
      break;
  }
  return url;
};

var prettyLiveHubUrl = function prettyLiveHubUrl(site) {
  var path = '';
  var url = '';
  //let pahtprefix = configJson.urlToUse === 'production' ? 'www' : 'dev';
  var pahtprefix = configJson.urlToUse === 'production' ? 'www' : 'www';

  switch (site) {
    case 'gazzetta':
      path = 'https://' + pahtprefix + '.gazzetta.it/risultati-live/';
      break;
    case 'corriere':
      path = 'https://' + pahtprefix + '.corriere.it/sport/risultati-live/';
      break;
    case 'fcinter':
    case 'fcinter1908':
      path = 'https://' + pahtprefix + '.fcinter1908.it/competizioni-calcio/risultati-live/';
      break;
    case 'forzaroma':
      path = 'https://' + pahtprefix + '.forzaroma.info/competizioni-calcio/risultati-live/';
      break;
    case 'calcionapoli1926':
      path = 'https://' + pahtprefix + '.calcionapoli1926.it/competizioni-calcio/risultati-live/';
      break;
    default:
      break;
  }

  url = '' + path;

  return url;
};

var prettyCalendarTennisUrl = function prettyCalendarTennisUrl(sportId, competitionId, competitionName, tournamentType, tournamentName, isTable, site) {
  var tournamentTypeLink = '';
  var tournamentLinkName = '';
  var url = '';
  var path = '';
  var pahtprefix = configJson.urlToUse === 'production' ? 'www' : 'www';
  var prefix = '';
  var postfix = '';
  var fallbackUrl = false;

  sportId = String(sportId);
  competitionId = String(competitionId);

  if (tournamentType) {
    tournamentTypeLink = '' + cleanTeamOrNameUrl(configJson.dictionary.it.competitionTable.tennisTournamentType[tournamentType], '-');
  } else {
    fallbackUrl = true;
  }

  if (tournamentName) {
    tournamentLinkName += cleanTeamOrNameUrl(tournamentName, '-') + '-';
  }

  if (competitionName) {
    var competitionReplaceName = competitionName;
    if (configJson.dictionary.it.competitionTable.tennisCompetitionName[competitionName]) {
      competitionReplaceName = configJson.dictionary.it.competitionTable.tennisCompetitionName[competitionName];
    }
    tournamentLinkName += cleanTeamOrNameUrl(competitionReplaceName, '-') + '-';
  }

  if (tournamentLinkName !== '') {
    tournamentLinkName += '' + competitionId;
  } else {
    fallbackUrl = true;
  }

  switch (site) {
    case 'gazzetta':
      path = 'https://' + pahtprefix + '.gazzetta.it';
      break;
    case 'corriere':
      path = 'https://' + pahtprefix + '.corriere.it/sport';
      break;
    case 'fcinter':
    case 'fcinter1908':
      path = 'https://' + pahtprefix + '.fcinter1908.it';
      break;
    case 'forzaroma':
      path = 'https://' + pahtprefix + '.forzaroma.info';
      break;
    case 'calcionapoli1926':
      path = 'https://' + pahtprefix + '.calcionapoli1926.it';
      break;
    default:
      break;
  }

  switch (sportId) {
    case '1':
      if (site === 'fcinter' || site === 'fcinter1908' || site === 'forzaroma' || site === 'calcionapoli1926') {
        prefix = '/competizioni-calcio';
      } else {
        prefix = '/calcio';
      }
      postfix = 'calendario-risultati';
      break;
    case '6C':
    case '6M':
      prefix = '/motori';
      postfix = 'piloti';
      break;
    case '8':
      prefix = '/tennis';
      postfix = isTable ? 'tabellone' : 'calendario-risultati';
      break;
    default:
      break;
  }

  url = '' + path + prefix + '/' + tournamentTypeLink + '/' + tournamentLinkName + '/' + postfix + '/';

  return !fallbackUrl ? url : '#';
};

var prettySeasonTennisUrl = function prettySeasonTennisUrl(sportId, competitionName, isStanding, site) {
  var competitionId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

  var standingLink = '';
  var url = '';
  var path = '';
  var pahtprefix = configJson.urlToUse === 'production' ? 'www' : 'www';
  var prefix = '';
  var postfix = '';

  sportId = String(sportId);
  if (!competitionName && competitionId) {
    switch (competitionId) {
      case 12324:
        competitionName = 'Mixed Doubles';break;
      case 12323:
        competitionName = 'Womens Doubles';break;
      case 12321:
        competitionName = 'Mens Doubles';break;
      case 12320:
        competitionName = 'Mens Singles';break;
      case 11047:
        competitionName = 'Womens Singles';break;
      default:
        competitionName = 'Mens Singles';
    }
  }

  switch (competitionName) {
    case 'Mens Singles':
    case 'Mens Doubles':
    case 'Mixed Doubles':
    case 'Mixed Singles':
      standingLink = 'atp';
      break;
    case 'Womens Singles':
    case 'Womens Doubles':
      standingLink = 'wta';
      break;
    case 'davis-cup':
    case 'fed-cup':
      standingLink = competitionName;
      break;
    default:
      standingLink = '';
      break;
  }

  switch (site) {
    case 'gazzetta':
      path = 'https://' + pahtprefix + '.gazzetta.it';
      break;
    case 'corriere':
      path = 'https://' + pahtprefix + '.corriere.it/sport';
      break;
    default:
      break;
  }

  switch (sportId) {
    case '1':
      if (site === 'fcinter' || site === 'fcinter1908' || site === 'forzaroma' || site === 'calcionapoli1926') {
        prefix = '/competizioni-calcio';
      } else {
        prefix = '/calcio';
      }
      postfix = 'calendario-risultati';
      break;
    case '6C':
    case '6M':
      prefix = '/motori';
      postfix = 'piloti';
      break;
    case '8':
      prefix = '/tennis';
      postfix = isStanding ? 'classifica-singolare' : 'calendario';
      break;
    default:
      break;
  }

  url = '' + path + prefix + '/' + standingLink + '/' + postfix + '/';

  return url;
};

var prettySeasonSkiUrl = function prettySeasonSkiUrl(sportId, competitionSex, eventId, place, competitionType, site) {
  var competitionSexLink = '';
  var competitionTypeLink = '';
  var placeLink = '';
  var url = '';
  var path = '';
  var pahtprefix = configJson.urlToUse === 'production' ? 'www' : 'www';
  var prefix = '';
  var postfix = '';

  sportId = String(sportId);

  placeLink = '' + cleanTeamOrNameUrl(place, '-', sportId);
  competitionTypeLink = '' + cleanTeamOrNameUrl(competitionType, '-');

  switch (site) {
    case 'gazzetta':
      path = 'https://' + pahtprefix + '.gazzetta.it';
      break;
    case 'corriere':
      path = 'https://' + pahtprefix + '.corriere.it/sport';
      break;
    case 'fcinter':
    case 'fcinter1908':
      path = 'https://' + pahtprefix + '.fcinter1908.it';
      break;
    case 'forzaroma':
      path = 'https://' + pahtprefix + '.forzaroma.info';
      break;
    case 'calcionapoli1926':
      path = 'https://' + pahtprefix + '.calcionapoli1926.it';
      break;
    default:
      break;
  }

  switch (sportId) {
    case '12':
      if (site === 'gazzetta') {
        prefix = '/sport-invernali/sci-alpino';
        postfix = 'gara';
      } else {
        postfix = 'gara';
      }
      break;
    default:
      break;
  }

  switch (competitionSex) {
    case 'man':
      if (site === 'gazzetta') {
        if (place === 'Cortina dAmpezzo') {
          competitionSexLink = 'mondiali-sci-maschile';
        } else {
          competitionSexLink = 'coppa-mondo-sci-maschile';
        }
      } else if (site === 'corriere') {
        if (place === 'Cortina dAmpezzo') {
          competitionSexLink = 'mondiali-sci-cortina-2021/classifica-maschile';
        } else {
          competitionSexLink = 'coppa-mondo-sci-maschile';
        }
      }
      break;
    case 'woman':
      if (site === 'gazzetta') {
        if (place === 'Cortina dAmpezzo') {
          competitionSexLink = 'mondiali-sci-femminile';
        } else {
          competitionSexLink = 'coppa-mondo-sci-femminile';
        }
      } else if (site === 'corriere') {
        if (place === 'Cortina dAmpezzo') {
          competitionSexLink = 'mondiali-sci-cortina-2021/classifica-femminile';
        } else {
          competitionSexLink = 'coppa-mondo-sci-femminile';
        }
      }
      break;
    default:
      break;
  }

  url = '' + path + prefix + '/' + competitionSexLink + '/' + postfix + '/' + competitionTypeLink + '-' + eventId + '/' + placeLink + '/';

  return url;
};

var prettyMotorCalendarUrl = function prettyMotorCalendarUrl(sportId, competitionId, site) {
  var path = prettySitePath(site);
  var competitionLink = '';
  var prefix = '/motori';
  var postfix = 'calendario-risultati';

  switch (sportId) {
    case '6C':
    case '6M':
      competitionLink = configJson.dictionary.it.raceCompetitionLink[competitionId];
      break;
    default:
      break;
  }
  return '' + path + prefix + '/' + competitionLink + '/' + postfix + '/';
};

var configFlags = {
  ALB: 'albania',
  AND: 'andorra',
  ARG: 'argentina',
  ARM: 'armenia',
  AUS: 'australia',
  AUT: 'austria',
  AZE: 'azerbaigian',
  BEL: 'belgio',
  BIH: 'bosnia-erzegovina',
  BLR: 'bielorussia',
  BOL: 'bolivia',
  BRA: 'brasile',
  BUL: 'bulgaria',
  CAN: 'canada',
  CHL: 'cile',
  CHN: 'cina',
  CIP: 'cipro',
  CMR: 'camerun',
  COK: 'nuova-zelanda',
  COL: 'colombia',
  COR: 'corea-del-sud',
  CRO: 'croazia',
  CUB: 'cuba',
  CZE: 'repubblica-ceca',
  DNK: 'danimarca',
  ECU: 'ecuador',
  EGI: 'egitto',
  ESP: 'spagna',
  EST: 'estonia',
  FAR: 'isole-far-oer',
  FIN: 'finlandia',
  FRA: 'francia',
  GAL: 'galles',
  GBR: 'inghilterra',
  'GB-ENG': 'inghilterra',
  'GB-SCT': 'scozia',
  GEO: 'georgia',
  GER: 'germania',
  GIB: 'gibilterra',
  GRC: 'grecia',
  HRV: 'croazia',
  HUN: 'ungheria',
  IRL: 'irlanda',
  IRN: 'iran',
  ISL: 'islanda',
  ISR: 'israele',
  ITA: 'italia',
  JAM: 'giamaica',
  JPN: 'giappone',
  KAZ: 'kazakistan',
  KEN: 'kenya',
  KOR: 'sud-corea',
  KOS: 'kosovo',
  LAT: 'lettonia',
  LIE: 'liechtenstein',
  LTU: 'lituania',
  LUX: 'lussemburgo',
  MDA: 'moldavia',
  MKD: 'north-macedonia',
  MLT: 'malta',
  MES: 'messico',
  MNE: 'montenegro',
  NED: 'olanda',
  NGA: 'nigeria',
  NIR: 'irlanda-del-nord',
  NOFLAG: 'no-flag',
  NOR: 'norvegia',
  PER: 'peru',
  POL: 'polonia',
  POR: 'portogallo',
  PRY: 'paraguay',
  QAT: 'qatar',
  ROU: 'romania',
  SPA: 'spagna',
  SRB: 'serbia',
  THL: 'tailandia',
  TUN: 'tunisia',
  PRC: 'porto-rico',
  RUS: 'russia',
  SUI: 'svizzera',
  SVK: 'slovacchia',
  SLO: 'slovenia',
  SAN: 'san-marino',
  SWE: 'svezia',
  THA: 'tailandia',
  TUR: 'turchia',
  UAE: 'emirati-arabi',
  UKR: 'ucraina',
  URY: 'uruguay',
  USA: 'stati-uniti',
  VEN: 'venezuela',
  ZAF: 'sud-africa'
};

var countryCode = (_countryCode = {
  albania: 'ALB',
  andorra: 'AND',
  argentina: 'ARG',
  australia: 'AUS',
  austria: 'AUT',
  azerbaigian: 'AZE',
  belgio: 'BEL',
  belgium: 'BEL',
  'bosnia-erzegovina': 'BIH',
  bielorussia: 'BLR',
  brazil: 'BRA',
  bahrain: 'BRN',
  bulgaria: 'BUL',
  canada: 'CAN',
  croazia: 'CRO',
  'czech-republic': 'CZE',
  cina: 'CHN',
  china: 'CHN',
  cipro: 'CIP',
  spagna: 'ESP',
  spain: 'ESP',
  estonia: 'EST',
  'isole-far-oer': 'FAR',
  finlandia: 'FIN',
  francia: 'FRA',
  france: 'FRA',
  galles: 'GAL',
  georgia: 'GEO',
  inghilterra: 'GBR',
  'united-kingdom': 'GBR',
  'great-britain': 'GBR',
  scozia: 'GB-SCT',
  germania: 'GER',
  germany: 'GER',
  gibilterra: 'GIB',
  grecia: 'GRC',
  ungheria: 'HUN'
}, _defineProperty(_countryCode, 'croazia', 'HVR'), _defineProperty(_countryCode, 'kazakistan', 'KAZ'), _defineProperty(_countryCode, 'irlanda', 'IRL'), _defineProperty(_countryCode, 'islanda', 'ISL'), _defineProperty(_countryCode, 'israele', 'ISR'), _defineProperty(_countryCode, 'italia', 'ITA'), _defineProperty(_countryCode, 'italy', 'ITA'), _defineProperty(_countryCode, 'japan', 'JPN'), _defineProperty(_countryCode, 'kosovo', 'KOS'), _defineProperty(_countryCode, 'lettonia', 'LAT'), _defineProperty(_countryCode, 'liechtenstein', 'LIE'), _defineProperty(_countryCode, 'lituania', 'LTU'), _defineProperty(_countryCode, 'lussemburgo', 'LUX'), _defineProperty(_countryCode, 'moldavia', 'MDA'), _defineProperty(_countryCode, 'malaysia', 'MYS'), _defineProperty(_countryCode, 'mexico', 'MEX'), _defineProperty(_countryCode, 'north-macedonia', 'MKD'), _defineProperty(_countryCode, 'malta', 'MLT'), _defineProperty(_countryCode, 'montenegro', 'MNE'), _defineProperty(_countryCode, 'monaco', 'MON'), _defineProperty(_countryCode, 'netherlands', 'NLD'), _defineProperty(_countryCode, 'olanda', 'NED'), _defineProperty(_countryCode, 'irlanda-del-nord', 'NIR'), _defineProperty(_countryCode, 'polonia', 'POL'), _defineProperty(_countryCode, 'qatar', 'QAT'), _defineProperty(_countryCode, 'russia', 'RUS'), _defineProperty(_countryCode, 'san-marino', 'SAN'), _defineProperty(_countryCode, 'singapore', 'SIN'), _defineProperty(_countryCode, 'svizzera', 'SUI'), _defineProperty(_countryCode, 'slovacchia', 'SVK'), _defineProperty(_countryCode, 'slovenia', 'SLO'), _defineProperty(_countryCode, 'thailand', 'THA'), _defineProperty(_countryCode, 'turchia', 'TUR'), _defineProperty(_countryCode, 'emirati-arabi', 'UAE'), _defineProperty(_countryCode, 'united-arab-emirates', 'UAE'), _defineProperty(_countryCode, 'ucraina', 'UKR'), _defineProperty(_countryCode, 'stati-uniti', 'USA'), _defineProperty(_countryCode, 'usa', 'USA'), _countryCode);

// competitionId impostate 352 - 383 - 408 - 128
var countriesIsoCode = {
  115: 'GB-SCT',
  116: 'IRL',
  117: 'NIR',
  118: 'ESP',
  119: 'ITA',
  357: 'GER',
  358: 'ROU',
  359: 'POR',
  360: 'BEL',
  361: 'SWE',
  362: 'TUR',
  363: 'NOR',
  364: 'SRB',
  365: 'SLO',
  366: 'NED',
  367: 'CZE',
  368: 'FRA',
  495: 'SAN',
  496: 'LUX',
  497: 'SUI',
  498: 'FAR',
  499: 'AND',
  500: 'EST',
  501: 'CIP',
  502: 'BUL',
  503: 'ISL',
  504: 'MKD',
  505: 'AZE',
  506: 'MDA',
  507: 'SVK',
  508: 'GAL',
  509: 'ARM',
  510: 'UKR',
  511: 'POL',
  512: 'BLR',
  513: 'LAT',
  514: 'LIE',
  516: 'ISR',
  517: 'GRC',
  518: 'FIN',
  519: 'LTU',
  520: 'GEO',
  521: 'MLT',
  524: 'GBR',
  534: 'ALB',
  535: 'CRO',
  536: 'RUS',
  537: 'BIH',
  538: 'HUN',
  614: 'BRA',
  632: 'ARG',
  830: 'ECU',
  831: 'CHL',
  832: 'COL',
  833: 'VEN',
  834: 'PER',
  835: 'PRY',
  836: 'BOL',
  837: 'URY',
  1266: 'JPN',
  1846: 'KAZ',
  1873: 'QAT',
  2101: 'POR',
  2104: 'NED',
  2105: 'ITA',
  2106: 'BEL',
  2107: 'CZE',
  2108: 'SRB',
  2109: 'ISR',
  2110: 'SVK',
  2734: 'MNE',
  2821: 'ESP',
  2822: 'CZE',
  3687: 'FIN',
  3688: 'ESP',
  3689: 'GER',
  3690: 'SWE',
  3691: 'BLR',
  4701: 'MNE',
  4779: 'SUI',
  5538: 'GRC',
  6231: 'AUS',
  6232: 'JPN',
  6235: 'NGA',
  6236: 'CAN',
  6238: 'USA',
  6239: 'BRA',
  6241: 'COK',
  6242: 'GBR',
  6243: 'FRA',
  6244: 'GER',
  6245: 'NOR',
  6246: 'SWE',
  6249: 'ISL',
  6250: 'DNK',
  6251: 'UKR',
  6322: 'ARG',
  6324: 'DNK',
  6325: 'CHN',
  6326: 'KOR',
  6330: 'NOR',
  6340: 'NED',
  6328: 'ITA',
  6518: 'AZE',
  6636: 'GB-SCT',
  6637: 'FRA',
  6638: 'LAT',
  6640: 'ROU',
  6641: 'KAZ',
  6812: 'SUI',
  6813: 'FIN',
  6955: 'ZAF',
  6957: 'CMR',
  7206: 'LIE',
  7211: 'IRL',
  7541: 'NIR',
  7648: 'ISL',
  7649: 'ESP',
  7696: 'RUS',
  7699: 'AUT',
  8880: 'GB-SCT',
  9069: 'ALB',
  9070: 'AND',
  9071: 'ARM',
  9072: 'BIH',
  9076: 'BUL',
  9078: 'HRV',
  9080: 'CIP',
  9081: 'EST',
  9082: 'FAR',
  9083: 'MKD',
  9084: 'GEO',
  9086: 'LTU',
  9087: 'LUX',
  9088: 'MLT',
  9089: 'MDA',
  9090: 'POL',
  9091: 'SAN',
  9093: 'TUR',
  9094: 'GAL',
  9180: 'NIR',
  9186: 'AUT',
  9493: 'GIB',
  9196: 'BEL',
  9197: 'POR',
  10330: 'THA',
  10655: 'ITA',
  10862: 'FRA',
  11658: 'KOS',
  11720: 'POR',
  12501: 'NOR',
  12587: 'KOS',
  12592: 'GIB',
  12674: 'CHL',
  14729: 'JAM',
  14774: 'ARM',
  15739: 'IRL'
};

var imageRacingMap = (_imageRacingMap = {
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  8: 8,
  14: 3,
  15: 15,
  17: 4,
  18: 8,
  19: 19,
  20: 20,
  21: 5,
  22: 22,
  24: 4,
  28: 8,
  29: 5,
  30: 8,
  33: 8,
  36: 5,
  37: 2,
  39: 22,
  46: 15,
  52: 20,
  53: 20,
  61: 61,
  79: 22,
  101: 19,
  102: 781,
  103: 20,
  104: 22,
  161: 5,
  162: 22,
  331: 331,
  501: 501,
  4161: 8,
  9271: 22,
  9321: 8,
  9341: 5,
  9751: 2,
  10021: 5,
  10301: 3,
  10311: 761,
  10371: 331,
  10381: 20,
  10411: 5,
  10421: 8,
  10461: 20,
  10531: 2,
  10541: 2,
  10551: 8,
  10561: 811,
  10571: 5,
  10581: 22,
  10591: 22,
  10761: 20,
  11091: 20,
  11101: 22,
  1781: 2,
  2681: 20,
  2741: 20,
  2751: 20,
  2761: 2,
  2801: 5,
  2911: 20,
  2941: 5,
  2961: 20,
  3821: 5,
  3961: 5,
  4011: 331,
  4141: 22,
  4301: 4,
  4351: 22,
  4791: 6,
  4821: 4,
  4911: 1,
  4921: 5,
  4941: 20,
  4971: 5,
  5001: 22,
  5011: 5,
  5341: 20,
  5511: 20,
  5641: 501,
  5861: 1,
  6241: 22,
  6271: 781,
  6281: 20,
  6311: 5,
  6481: 8,
  6861: 22,
  6881: 5,
  6901: 4,
  7051: 2,
  7061: 2,
  7071: 20,
  7081: 20,
  7121: 5,
  7521: 22,
  7691: 5,
  7931: 5,
  7941: 5,
  8111: 8,
  8121: 5,
  8171: 20,
  8181: 20,
  8191: 22,
  8201: 22,
  8211: 22,
  8351: 4,
  8471: 20,
  8551: 6,
  8561: 4,
  8571: 8,
  8581: 6,
  9191: 8,
  9201: 22,
  9231: 20,
  9241: 22,
  9251: 5,
  9261: 5,
  9281: 5,
  9291: 431,
  9331: 2
}, _defineProperty(_imageRacingMap, '9341', 5), _defineProperty(_imageRacingMap, 9471, 20), _defineProperty(_imageRacingMap, 9481, 2), _defineProperty(_imageRacingMap, 9491, 8), _defineProperty(_imageRacingMap, 9511, 1), _defineProperty(_imageRacingMap, 9781, 8), _defineProperty(_imageRacingMap, 10001, 22), _defineProperty(_imageRacingMap, 10041, 22), _defineProperty(_imageRacingMap, 10161, 22), _defineProperty(_imageRacingMap, 10171, 8), _defineProperty(_imageRacingMap, 10271, 22), _defineProperty(_imageRacingMap, 10281, 22), _defineProperty(_imageRacingMap, 10241, 4), _defineProperty(_imageRacingMap, 10361, 2), _defineProperty(_imageRacingMap, 10751, 2), _defineProperty(_imageRacingMap, 11761, 2), _defineProperty(_imageRacingMap, 11621, 1), _defineProperty(_imageRacingMap, 8931, 5), _defineProperty(_imageRacingMap, 11771, 22), _defineProperty(_imageRacingMap, 11781, 781), _defineProperty(_imageRacingMap, 11631, 781), _defineProperty(_imageRacingMap, 11871, 781), _defineProperty(_imageRacingMap, 7611, 1071), _defineProperty(_imageRacingMap, 11641, 5), _defineProperty(_imageRacingMap, 11921, 5), _imageRacingMap);

var getVolleyTeamImagePath = function getVolleyTeamImagePath(imagesURL, team, competitionId) {
  var path = '' + imagesURL;
  var findLogo = false;
  var localTeamCode = false;
  if (typeof team.toJS === 'function') {
    team = team.toJS();
  }
  if (team.logoTeamId) {
    var _team = team,
        logoTeamId = _team.logoTeamId;

    if (!isVolleyCup(competitionId)) {
      findLogo = logoTeamId;
    }
    if (countriesIsoCode[logoTeamId]) {
      localTeamCode = countriesIsoCode[logoTeamId];
    }
  }
  if (localTeamCode === false && team.teamCode) {
    localTeamCode = team.teamCode;
  }
  if (localTeamCode && configFlags[localTeamCode] && findLogo === false) {
    findLogo = configFlags[localTeamCode];
  }
  if (findLogo) {
    path += findLogo + '.png';
  } else {
    return false;
  }
  return path;
};

var getFootballTeamImagePath = function getFootballTeamImagePath(imagesURL, team) {
  var path = '' + imagesURL;
  if (typeof team.toJS === 'function') {
    team = team.toJS();
  }
  if (!teamHasLink(team.teamName)) {
    return '';
  }
  var _team2 = team,
      teamId = _team2.teamId;

  if (String(teamId) === '000000' && team.teamName) {
    var teamName = cleanTeamOrNameUrl(team.teamName, '-');
    path += teamName + '.png';
  } else if (countriesIsoCode[team.teamId]) {
    var teamCode = countriesIsoCode[team.teamId];
    if (configFlags[teamCode]) {
      path += configFlags[teamCode] + '.png';
    }
  } else {
    path += team.teamId + '.png';
  }
  return path;
};

var configCompetitions = {
  1: {
    3: {
      showSmallStandings: true, isSingleMatch: true, competitionRoundLink: true, teamsLink: true, footballCup: true, onlyFirstLeg: true, showMatchQuote: true
    },
    4: {
      teamsLink: true, footballCup: true, isSingleMatch: true, showMatchQuote: true
    },
    5: {
      showSmallStandings: true, isSingleMatch: true, teamsLink: true, footballCup: true, showMatchQuote: true, hidePlayOffTabStanding: false
    },
    6: {
      showSmallStandings: true, isSingleMatch: true, teamsLink: true, footballCup: true, showMatchQuote: true, hidePlayOffTabStanding: false, onlyFirstLeg: false
    },
    1125: {
      showSmallStandings: true, isSingleMatch: true, teamsLink: true, footballCup: true, showMatchQuote: false, hidePlayOffTabStanding: false
    },
    8: {
      teamsLink: true, showMatchQuote: true, hideMatchStatistics: true, hideMatchCommentary: true, hideMatchSynthesis: true
    },
    21: {
      showSmallStandings: true, isSingleMatch: true, teamsLink: true, showMatchQuote: true, showMatchVotation: false
    },
    22: {
      teamsLink: true, showMatchQuote: true, hideMatchStatistics: true, hideMatchCommentary: true, hideMatchSynthesis: true
    },
    23: {
      teamsLink: true, showMatchQuote: true, hideMatchStatistics: true, hideMatchCommentary: true, hideMatchSynthesis: true
    },
    24: {
      teamsLink: true, showMatchQuote: true, hideMatchStatistics: true, hideMatchCommentary: true, hideMatchSynthesis: true
    },
    105: { showSmallStandings: true, isSingleMatch: true, teamsLink: true },
    112: { teamsLink: true },
    128: {
      showSmallStandings: true, isSingleMatch: true, onlyFirstLeg: true, competitionRoundLink: true, footballCup: true
    },
    173: { teamsLink: true, onlyFirstLeg: true, footballCup: true },
    174: { teamsLink: true },
    259: {
      competitionRoundLink: true, teamsLink: true, footballCup: true, hideStandingLink: true
    },
    335: {
      showSmallStandings: false, isSingleMatch: true, onlyFirstLeg: true, footballCup: true, hideStandingLink: true
    },
    1277: {
      teamsLink: true, showSmallStandings: false, isSingleMatch: true, onlyFirstLeg: true, footballCup: true, hideMatchStatistics: true
    },
    352: {
      showSmallStandings: true, isSingleMatch: true, onlyFirstLeg: true, competitionRoundLink: true, footballCup: true
    },
    383: {
      showSmallStandings: true, isSingleMatch: true, onlyFirstLeg: true, competitionRoundLink: true, footballCup: true
    },
    408: {
      showSmallStandings: true, isSingleMatch: true, onlyFirstLeg: true, competitionRoundLink: true, footballCup: true
    },
    616: {
      showSmallStandings: true, isSingleMatch: true, onlyFirstLeg: true, competitionRoundLink: true, footballCup: true, hideLiveLink: true
    },
    941: {
      competitionRoundLink: true, teamsLink: true, footballCup: true, onlyFirstLeg: true, isSingleMatch: true, showSmallStandings: true
    }
  },
  3: {
    1: {
      teamsLink: true, hideMatchStatistics: true, hideMatchCommentary: true, hideMatchSynthesis: true
    },
    2: { teamsLink: false },
    3: { teamsLink: true },
    6: { basketCup: true, teamsLink: true, hideStandingSwitchHomeAway: true },
    7: { basketCup: true, teamsLink: true, hideStandingSwitchHomeAway: true }
  },
  5: {
    34: { volleyCup: true },
    35: { volleyCup: true },
    53: { volleyCup: true },
    54: { volleyCup: true }
  },
  '6C': {
    1: { showMatchQuote: true }
  },
  '6M': {
    2: { showMatchQuote: true },
    3: { showMatchQuote: true },
    4: { showMatchQuote: true },
    5: { showMatchQuote: true }
  },
  8: {
    3: { showMatchQuote: true },
    10148: { showMatchQuote: true },
    10025: { showMatchQuote: true },
    10149: { showMatchQuote: true },
    10026: { showMatchQuote: true },
    10147: { showMatchQuote: true },
    10199: { showMatchQuote: true },
    10069: { showMatchQuote: true },
    10200: { showMatchQuote: true },
    10070: { showMatchQuote: true },
    10198: { showMatchQuote: true },
    10214: { showMatchQuote: true },
    10089: { showMatchQuote: true },
    10215: { showMatchQuote: true },
    10090: { showMatchQuote: true },
    10213: { showMatchQuote: true },
    10243: { showMatchQuote: true },
    10135: { showMatchQuote: true },
    10244: { showMatchQuote: true },
    10136: { showMatchQuote: true },
    10242: { showMatchQuote: true },
    10222: { showMatchQuote: true },
    10228: { showMatchQuote: true },
    10117: { showMatchQuote: true }
  }
};

var lowerCaseFirstLetter = function lowerCaseFirstLetter(value) {
  return '' + value.charAt(0).toLowerCase() + value.slice(1);
};

var hasParam = function hasParam(sportId, competitionId, param) {
  if (configCompetitions[sportId] && configCompetitions[String(sportId)][String(competitionId)]) {
    if (param.indexOf('is') === 0) {
      param = param.substring(2, param.length);
    }
    param = lowerCaseFirstLetter(param);
    var configCompetition = configCompetitions[String(sportId)][String(competitionId)];
    if (configCompetition[param] && configCompetition[param] === true) {
      return true;
    }
  }
  return false;
};

var isHideStandingSwitchHomeAway = function isHideStandingSwitchHomeAway(sportId, competitionId) {
  return hasParam(sportId, competitionId, 'isHideStandingSwitchHomeAway');
};

var isFootballCup = function isFootballCup(sportId, competitionId) {
  return hasParam(sportId, competitionId, 'isFootballCup');
};

var isBasketCup = function isBasketCup(competitionId) {
  return hasParam('3', competitionId, 'isBasketCup');
};

var isVolleyCup = function isVolleyCup(competitionId) {
  return hasParam('5', competitionId, 'isVolleyCup');
};

var isOnlyFirstLeg = function isOnlyFirstLeg(sportId, competitionId) {
  return hasParam(sportId, competitionId, 'isOnlyFirstLeg');
};

var isCompetitionRoundLink = function isCompetitionRoundLink(sportId, competitionId) {
  return hasParam(sportId, competitionId, 'isCompetitionRoundLink');
};

var isHideStandingLink = function isHideStandingLink(sportId, competitionId) {
  return hasParam(sportId, competitionId, 'isHideStandingLink');
};

var isHideLiveLink = function isHideLiveLink(sportId, competitionId) {
  return hasParam(sportId, competitionId, 'isHideLiveLink');
};

var showMatchQuote = function showMatchQuote(sportId, competitionId) {
  return hasParam(sportId, competitionId, 'showMatchQuote');
};

var hidePlayOffTabStanding = function hidePlayOffTabStanding(sportId, competitionId) {
  return hasParam(sportId, competitionId, 'hidePlayOffTabStanding');
};

var showMatchVotation = function showMatchVotation(sportId, competitionId) {
  return hasParam(sportId, competitionId, 'showMatchVotation');
};

var hideMatchStatistics = function hideMatchStatistics(sportId, competitionId) {
  return hasParam(sportId, competitionId, 'hideMatchStatistics');
};

var hideMatchCommentary = function hideMatchCommentary(sportId, competitionId) {
  return hasParam(sportId, competitionId, 'hideMatchCommentary');
};

var hideMatchSynthesis = function hideMatchSynthesis(sportId, competitionId) {
  return hasParam(sportId, competitionId, 'hideMatchSynthesis');
};

var teamHasLink = function teamHasLink(teamName, sportId, competitionId) {
  if (!sportId || !competitionId) return true;
  if (sportId && competitionId && !hasParam(sportId, competitionId, 'isTeamsLink')) {
    return false;
  }
  var excludeTeam = ['TBC', 'Perdente 2° Turno 1', 'Perdente 2° Turno 2', 'Perdente Semifinale 1', 'Perdente Semifinale 2', 'Vincitrice Semifinale 1', 'Vincitrice Semifinale 2'];
  if (!teamName || excludeTeam.includes(teamName) || teamName.toLowerCase().indexOf('group') > -1 || teamName.toLowerCase().indexOf('finalist') > -1 || teamName.toLowerCase().indexOf('vincit') > -1 || teamName.toLowerCase().indexOf('vincent') > -1 || teamName.toLowerCase().indexOf('vincent') > -1 || teamName.toLowerCase().indexOf('classificat') > -1 || teamName.toLowerCase().indexOf('girone') > -1 || teamName.toLowerCase().indexOf('gironi') > -1 || teamName.toLowerCase().indexOf('winner') > -1 || teamName.toLowerCase().indexOf('assegnat') > -1 || teamName.toLowerCase().indexOf('loser') > -1) {
    return false;
  }
  return true;
};

var teamNameLabel = function teamNameLabel(teamName) {
  if (teamHasLink(teamName)) {
    return teamName;
  }
  return '- -';
};

var subPhaseLabel = function subPhaseLabel(index, dictionary, sportId, competitionId) {
  var isFrontend = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  var newIndex = index + '_' + sportId + '_' + competitionId;
  if (!dictionary[newIndex]) {
    newIndex = index + '_' + sportId;
  }
  if (!dictionary[newIndex]) {
    newIndex = '' + index;
  }

  var label = index;
  if (dictionary[newIndex]) {
    label = dictionary[newIndex];
  }

  if (isFrontend) {
    label = label.replace('&deg;', '°');
  }

  return label;
};

var parseCompetitionName = function parseCompetitionName(competitionName, competitionId, dictionary) {
  var isFrontend = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var label = '';
  if (dictionary[competitionId]) {
    label = dictionary[competitionId];
  }

  if (isFrontend) {
    label = label.replace('&deg;', '°');
  }

  return label;
};

var isPlayoffs = function isPlayoffs(phase) {
  if (phase && phase.toLowerCase().indexOf('playoff') > -1) {
    return true;
  }
  return false;
};

var getLegendaElements = function getLegendaElements(sportId, competitionId) {
  var isEuropeanCup = String(sportId) === '1' && (String(competitionId) === '5' || String(competitionId) === '6' || String(competitionId) === '1125');
  var elements = [{ bgColor: 'mediumBlue', label: 'Champions League' }, { bgColor: 'lightBlue', label: 'Preliminari C. League' }, { bgColor: 'lightRed', label: 'Europa League' }, { bgColor: 'lightPink', label: 'Preliminari E. League' }, { bgColor: 'lightGreen', label: 'Conference League' }, { bgColor: 'lightYellow', label: 'Retrocesse' }];
  if (String(sportId) === '1' && String(competitionId) === '105') {
    elements = [{ bgColor: 'mediumBlue', label: 'Promosse' }, { bgColor: 'lightRed', label: 'Playoff' }, { bgColor: 'mediumGreen', label: 'Playout' }, { bgColor: 'lightYellow', label: 'Retrocesse' }];
  }
  if (String(sportId) === '3' && String(competitionId) === '3') {
    elements = [{ bgColor: 'mediumBlue', label: 'Prime' }, { bgColor: 'lightRed', label: 'Prime' }, { bgColor: 'lightBlue', label: 'Qualificata ai Playoff' }, { bgColor: 'lightYellow', label: 'Eliminata dai Playoff' }];
  }
  if (isEuropeanCup) {
    elements = [{ bgColor: 'mediumBlue', label: 'Agli ottavi' }, { bgColor: 'lightRed', label: 'Ai playoff' }];
  }
  return elements;
};

var getClinchStatusColor = function getClinchStatusColor(clinchStatus) {
  var clinches = {
    3: 'mediumBlue',
    2: 'lightRed',
    1: 'lightBlue',
    0: '',
    '-1': 'lightYellow'
  };
  if (clinchStatus) {
    if (clinchStatus === 'ALL') {
      return clinches;
    } else if (clinches[clinchStatus]) {
      return clinches[clinchStatus];
    }
  }
  return '';
};

var buildBasketData = function buildBasketData(data, phase) {
  var findBasketKey = function findBasketKey(value, outerGroups) {
    var ret = [];
    outerGroups.forEach(function (arr, j) {
      arr.forEach(function (v, k) {
        if (Array.isArray(v)) {
          v.forEach(function (val, y) {
            if (val === value) {
              ret = [j, k, y];
            }
          });
        } else if (v === value) {
          ret = [j, k];
        }
      });
    });
    return ret;
  };
  data.phaseRequest = phase;
  var isNba = String(data.competitionId) === '3';
  if (!data.competitionId) {
    return data;
  }
  if (String(data.competitionId) === '6' && String(phase) === '1' || String(data.competitionId) === '7' && String(phase) === '1' || String(data.competitionId) === '1' && String(phase) !== '2' || String(data.competitionId) === '2' && String(phase) !== '2' || String(data.competitionId) === '3' && String(phase) !== '3') {
    return data;
  }

  var phases = [];
  var firstPhase = { western: [[1, 8], [4, 5], [3, 6], [2, 7]], eastern: [[1, 8], [4, 5], [3, 6], [2, 7]] };
  var groupMaps = {
    2: [[1, 4], [5, 8], [3, 2], [7, 6]], //[A1, B2], [C1, D2], [B1, A2], [D1, C2]
    4: [[1, 8], [6, 3], [5, 4], [2, 7]], //[A1, B4], [B2, A3], [B1, A4], [A2, B3]
    8: [[1, 8], [4, 5], [3, 6], [2, 7]] //Playoff Regular Season
  };
  var tabellone = {};
  var tabelloneGroups = [];

  var isGroups = null;

  var prepareGroupTabellone = function prepareGroupTabellone(x) {
    if (tabelloneGroups.length === 0) {
      var t = [];
      var maxRank = x.maxRank,
          groupsCount = x.groupsCount,
          competitionRoundIds = x.competitionRoundIds;

      if (groupsCount) {
        var letters = competitionRoundIds || ['A', 'B', 'C', 'D'];
        var letterIndex = 0;
        var j = 0;
        var innerT = [];
        while (letterIndex < groupsCount) {
          if (j % 8 === 0) {
            innerT = [];
          }
          for (var i = 1; i <= maxRank; i += 1) {
            var label = '' + letters[letterIndex] + i;
            innerT.push(label);
            j += 1;
          }
          letterIndex += 1;
          if (j % 8 === 0) {
            t.push(innerT);
          }
        }
        t.forEach(function (inT) {
          var tab = [];
          inT.forEach(function (v, i) {
            var index = i + 1;
            var tabKey = findBasketKey(index, groupMaps[maxRank]);
            if (tabKey.length > 0) {
              if (typeof tab[tabKey[0]] === 'undefined') {
                tab[tabKey[0]] = [];
              }
              tab[tabKey[0]][tabKey[1]] = v;
            }
          });
          tabelloneGroups.push(tab);
        });
      } else if (maxRank) {
        var tab = [];
        for (var _i = 1; _i <= maxRank; _i += 1) {
          var tabKey = findBasketKey(_i, groupMaps[maxRank]);
          if (tabKey.length > 0) {
            if (typeof tab[tabKey[0]] === 'undefined') {
              tab[tabKey[0]] = [];
            }
            tab[tabKey[0]][tabKey[1]] = _i;
          }
        }
        tabelloneGroups.push(tab);
      }
    }
  };

  var reduceGroups = function reduceGroups() {
    var ret = [];
    var x = 0;
    if (tabelloneGroups.length > 0 && !isNba) {
      tabelloneGroups.forEach(function (k) {
        k.forEach(function (y) {
          if (Array.isArray(y)) {
            y.forEach(function (v) {
              if (typeof ret[x] === 'undefined') {
                ret[x] = [];
              }
              ret[x].push(v);
              if (ret[x].length >= 4) {
                x += 1;
              }
            });
          } else {
            if (typeof ret[x] === 'undefined') {
              ret[x] = [];
            }
            ret[x].push(y);
            if (ret[x].length >= 4) {
              x += 1;
            }
          }
        });
      });
    } else {
      Object.keys(firstPhase).forEach(function (conference) {
        if (tabellone[conference]) {
          tabellone[conference].forEach(function (arr) {
            arr.forEach(function (v) {
              if (typeof ret[x] === 'undefined') {
                ret[x] = [];
              }
              ret[x].push(v);
              if (ret[x].length >= 4) {
                x += 1;
              }
            });
          });
        }
      });
    }
    return ret;
  };

  var outerGroups = [];

  var setKey = function setKey(team, conference) {
    if (conference !== null) {
      var tabKey = findBasketKey(team.rank, firstPhase[conference]);
      if (tabKey.length > 0) {
        if (typeof tabellone[conference] === 'undefined') {
          tabellone[conference] = [];
        }
        if (typeof tabellone[conference][tabKey[0]] === 'undefined') {
          tabellone[conference][tabKey[0]] = [];
        }
        tabellone[conference][tabKey[0]][tabKey[1]] = team.teamId;
      }
    } else {
      var k = isGroups ? '' + team.competitionRoundId + team.rank : team.rank;
      var tabKe = findBasketKey(k, tabelloneGroups);
      if (tabKe.length === 3) {
        tabelloneGroups[tabKe[0]][tabKe[1]][tabKe[2]] = team.teamId;
      } else if (tabKe.length > 0) {
        tabelloneGroups[tabKe[0]][tabKe[1]] = team.teamId;
      }
    }
  };

  var findBasketKeyByRank = function findBasketKeyByRank(team, conference) {
    var ret = 0;
    if (conference !== null) {
      var tabKey = findBasketKey(team.rank, firstPhase[conference]);
      if (tabKey) {
        var _tabKey = _slicedToArray(tabKey, 1);

        ret = _tabKey[0];

        if (Object.keys(firstPhase).indexOf(conference) > 0 && isNba) {
          ret += 4;
        }
      }
    } else {
      var tabKe = findBasketKey(team.teamId, tabelloneGroups);

      var _tabKe = _slicedToArray(tabKe, 2),
          dec = _tabKe[0],
          unit = _tabKe[1];

      ret = dec * 4 + unit;
    }
    return ret;
  };

  var getTotalScore = function getTotalScore(team) {
    if (team.scores && team.scores.total) {
      return team.scores.total;
    }
    return '';
  };

  var excludeSubPhase = function excludeSubPhase(sPh) {
    var excludedSubPhase = ['3rd', '5th', '7th', 'play-in-tournament'];
    var ret = true;
    excludedSubPhase.forEach(function (val) {
      if (sPh.roundName.indexOf(val) > -1) {
        ret = false;
      }
    });
    return ret;
  };
  data.contents.reverse().filter(function (r) {
    return excludeSubPhase(r);
  }).forEach(function (x) {
    if (isNba || tabelloneGroups.length > 0 || x.maxRank && x.maxRank > 0 && groupMaps[x.maxRank]) {
      var partite = [];
      var keys = [];
      var groups = [];
      if (!isNba) {
        prepareGroupTabellone(x);
      }
      if (isGroups === null) {
        isGroups = !!x.isGroups;
      }
      x.games.forEach(function (game) {
        /* ++++++++++++++++++++++++++  GAME  ++++++++++++++++++++++++++ */
        var findTeam = null;
        if (keys.indexOf(game.teamHome.teamId) > -1) {
          findTeam = game.teamHome;
        } else if (keys.indexOf(game.teamAway.teamId) > -1) {
          findTeam = game.teamAway;
        } else {
          keys.push(game.teamHome.teamId);
          findTeam = game.teamHome;
        }
        var key = void 0;

        var westernTeamCodes = ['LAL', // Los Angeles Lakers
        'DEN', // Denver Nuggets
        'HOU', // Houston Rockets
        'LAC', // Los Angeles Clippers,
        'DAL', // Dallas Mavericks
        'UTA', // Utah Jazz
        'OKC', // Oklahoma City Thunder
        'POR', // Portland Trail Blazers
        'GSW', // Golden State Warriors
        'MIN', // Minnesota Timberwolves
        'MEM', // Memphis Grizzlies
        'NOP', // New Orleans Pelicans
        'PHX', // Phoenix Suns
        'SAS', // San Antonio Spurs
        'SAC'];

        var easternTeamCodes = ['MIL', // Milwaukee Bucks
        'BOS', // Boston Celtics
        'IND', // Indiana Pacers
        'TOR', // Toronto Raptors
        'ORL', // Orlando Magic
        'BKN', // Brooklyn Nets
        'PHI', // Philadelphia 76ers
        'MIA', // Miami Heat
        'ATL', // Atlanta Hawks
        'CHI', // Chicago Bulls
        'CHA', // Charlotte Hornets
        'CLE', // Cleveland Cavaliers
        'NYK', // New York Knicks
        'DET', // Detroit Pistons
        'WAS'];

        if (game.competition.subphase.indexOf('western') > -1 || game.competition.coast === 'western' || westernTeamCodes.indexOf(findTeam.teamCode) > -1) {
          game.conference = 'western';
        } else if (game.competition.subphase.indexOf('eastern') > -1 || game.competition.coast === 'eastern' || easternTeamCodes.indexOf(findTeam.teamCode) > -1) {
          game.conference = 'eastern';
        }
        var innerKey = 0;
        var isInverted = void 0;
        var isInvertedGr = void 0;
        if (outerGroups.length > 0) {
          if (findTeam.teamId) {
            var _findBasketKey = findBasketKey(findTeam.teamId, outerGroups);

            var _findBasketKey2 = _slicedToArray(_findBasketKey, 2);

            key = _findBasketKey2[0];
            innerKey = _findBasketKey2[1];

            var k = key % 2 === 0 ? key : key - 1;
            k /= 2;
            isInverted = innerKey >= outerGroups[0].length / 2;
            isInvertedGr = key % 2 !== 0;
            if (typeof groups[k] === 'undefined') {
              groups[k] = [];
            }
            if (groups[k].indexOf(game.teamHome.teamId) < 0 && groups[k].indexOf(game.teamAway.teamId) < 0) {
              var teamA = isInverted ? game.teamAway.teamId : game.teamHome.teamId;
              var teamB = isInverted ? game.teamHome.teamId : game.teamAway.teamId;
              if (isInvertedGr && x.games.length > 1) {
                if (groups[k].length === 0) {
                  groups[k] = [0, 0, teamA, teamB];
                } else {
                  groups[k] = [groups[k][0], groups[k][1], teamA, teamB];
                }
              } else {
                groups[k][0] = teamA;
                groups[k][1] = teamB;
              }
            }
          }
        } else {
          if (groups.indexOf(game.teamHome.teamId) < 0) {
            groups.push(game.teamHome.teamId);
          }
          if (groups.indexOf(game.teamAway.teamId) < 0) {
            groups.push(game.teamAway.teamId);
          }
          if (game.competition.subphase.indexOf('western') > -1 || game.competition.coast === 'western' || westernTeamCodes.indexOf(findTeam.teamCode) > -1) {
            setKey(game.teamHome, 'western');
            setKey(game.teamAway, 'western');
            key = findBasketKeyByRank(findTeam, 'western');
          } else if (game.competition.subphase.indexOf('eastern') > -1 || game.competition.coast === 'eastern' || easternTeamCodes.indexOf(findTeam.teamCode) > -1) {
            setKey(game.teamHome, 'eastern');
            setKey(game.teamAway, 'eastern');
            key = findBasketKeyByRank(findTeam, 'eastern');
          } else {
            setKey(game.teamHome, null);
            setKey(game.teamAway, null);
            key = findBasketKeyByRank(findTeam, null);
          }
        }
        game.homeTeam = Object.assign({}, game.teamHome, { teamName: game.teamHome.name, score: getTotalScore(game.teamHome) });
        delete game.homeTeam.scores;
        delete game.homeTeam.rank;
        game.awayTeam = Object.assign({}, game.teamAway, { teamName: game.teamAway.name, score: getTotalScore(game.teamAway) });
        delete game.awayTeam.scores;
        delete game.awayTeam.rank;
        if (getTotalScore(game.teamHome) && getTotalScore(game.teamAway) && game.status === 'PLAYED') {
          if (Number(getTotalScore(game.teamHome)) > Number(getTotalScore(game.teamAway))) {
            game.matchDetails = { winId: game.teamHome.teamId, lostId: game.teamAway.teamId };
          } else {
            game.matchDetails = { winId: game.teamAway.teamId, lostId: game.teamHome.teamId };
          }
        }
        if (!game.matchDetails || game.status !== 'PLAYED') {
          game.matchDetails = { winId: 0, lostId: 0 };
        }
        if (game.utcDate) {
          game.dateUtc = game.utcDate;
        }
        if (game.status.toLowerCase() === 'played') {
          game.isEnded = true;
        } else {
          game.isEnded = false;
        }
        isInverted = outerGroups.length > 0 && innerKey >= outerGroups[0].length / 2;
        if (typeof key === 'undefined') {
          key = partite.length;
        }
        if (typeof partite[key] === 'undefined') {
          partite[key] = {
            homeTeam: Object.assign({}, isInverted ? game.awayTeam : game.homeTeam, { score: 0 }),
            awayTeam: Object.assign({}, isInverted ? game.homeTeam : game.awayTeam, { score: 0 }),
            matches: [],
            isFiniscedSerie: false
          };
        }
        partite[key].matches.push(game);
        if (game.matchDetails.winId && partite[key].homeTeam.teamId === game.matchDetails.winId) {
          partite[key].homeTeam.score += 1;
        }
        if (game.matchDetails.winId && partite[key].awayTeam.teamId === game.matchDetails.winId) {
          partite[key].awayTeam.score += 1;
        }
      }); /* ++++++++++++++++++++++++++  FINE GAME  ++++++++++++++++++++++++++ */
      for (var i = 0; i < groups.length; i += 1) {
        if (typeof groups[i] === 'undefined') {
          groups[i] = [];
        }
      }
      outerGroups = outerGroups.length === 0 ? reduceGroups() : groups;
      if (outerGroups.length > 0) {
        var len = 0;
        for (var _i2 = 0; _i2 < outerGroups.length; _i2 += 1) {
          if (outerGroups[_i2].length > len) {
            len = outerGroups[_i2].length;
          }
        }
        var limit = outerGroups.length * len / 2;
        for (var _i3 = 0; _i3 < limit; _i3 += 1) {
          if (!partite[_i3]) {
            partite[_i3] = {};
          }
          var match = partite[_i3];
          if (match && match.homeTeam) {
            (function () {
              var filteredMatch = [];
              match.matches.map(function (x) {
                return x.status != 'POSTPONED' ? filteredMatch.push(x) : '';
              });
              var winnerMatches = Math.max(Number(match.homeTeam.score), Number(match.awayTeam.score));
              if (winnerMatches > filteredMatch.length / 2) {
                partite[_i3].isFiniscedSerie = true;
                partite[_i3].matches = partite[_i3].matches.filter(function (m) {
                  return m.status.toLowerCase() === 'played';
                });
              }
            })();
          }
        }
      }
      phases.push({ roundName: x.roundName, partite: partite });
    }
  });
  data.contents = phases;
  return data;
};

var addShootOutScore = function addShootOutScore(match) {
  var addTeamShootOutScore = function addTeamShootOutScore(team) {
    var baseScore = team.score ? parseInt(team.score, 10) : 0;
    var shootOutsScore = team.starData && team.starData.shootOuts && team.starData.shootOuts.score ? parseInt(team.starData.shootOuts.score, 10) : 0;
    team.scoreAfterShootOuts = (baseScore + shootOutsScore).toString();

    return team;
  };
  if (match.homeTeam) addTeamShootOutScore(match.homeTeam);
  if (match.awayTeam) addTeamShootOutScore(match.awayTeam);

  return match;
};

exports.configJson = configJson;
exports.prettyMatchUrl = prettyMatchUrl;
exports.prettyPlayerUrl = prettyPlayerUrl;
exports.prettyTopScorersUrl = prettyTopScorersUrl;
exports.prettyStandingsUrl = prettyStandingsUrl;
exports.prettyCalendarUrl = prettyCalendarUrl;
exports.cleanTeamOrNameUrl = cleanTeamOrNameUrl;
exports.prettyTeamUrl = prettyTeamUrl;
exports.prettyLiveHubUrl = prettyLiveHubUrl;
exports.prettyCalendarTennisUrl = prettyCalendarTennisUrl;
exports.prettySeasonTennisUrl = prettySeasonTennisUrl;
exports.prettySeasonSkiUrl = prettySeasonSkiUrl;
exports.prettyMotorCalendarUrl = prettyMotorCalendarUrl;
exports.configFlags = configFlags;
exports.countryCode = countryCode;
exports.prettyCyclingCompetitionId = prettyCyclingCompetitionId;
exports.prettyCyclingCompetitionLabel = prettyCyclingCompetitionLabel;
exports.teamNameLabel = teamNameLabel;
exports.teamHasLink = teamHasLink;
exports.configCompetitions = configCompetitions;
exports.isFootballCup = isFootballCup;
exports.isVolleyCup = isVolleyCup;
exports.isBasketCup = isBasketCup;
exports.isOnlyFirstLeg = isOnlyFirstLeg;
exports.isCompetitionRoundLink = isCompetitionRoundLink;
exports.isHideStandingSwitchHomeAway = isHideStandingSwitchHomeAway;
exports.isHideStandingLink = isHideStandingLink;
exports.isHideLiveLink = isHideLiveLink;
exports.getFootballTeamImagePath = getFootballTeamImagePath;
exports.getVolleyTeamImagePath = getVolleyTeamImagePath;
exports.subPhaseLabel = subPhaseLabel;
exports.buildBasketData = buildBasketData;
exports.isPlayoffs = isPlayoffs;
exports.parseCompetitionName = parseCompetitionName;
exports.imageRacingMap = imageRacingMap;
exports.showMatchQuote = showMatchQuote;
exports.showMatchVotation = showMatchVotation;
exports.hideMatchCommentary = hideMatchCommentary;
exports.hideMatchSynthesis = hideMatchSynthesis;
exports.hideMatchStatistics = hideMatchStatistics;
exports.hidePlayOffTabStanding = hidePlayOffTabStanding;
exports.getLegendaElements = getLegendaElements;
exports.getClinchStatusColor = getClinchStatusColor;
exports.addShootOutScore = addShootOutScore;


// WEBPACK FOOTER //
// ./src/common/rcs_gaz_mc_core_FE/build/config.js